/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppUsersIndexRouteImport } from './routes/_app.users.index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app.settings.index'
import { Route as AppRolesIndexRouteImport } from './routes/_app.roles.index'
import { Route as AppPopupsIndexRouteImport } from './routes/_app.popups.index'
import { Route as AppPaymentsIndexRouteImport } from './routes/_app.payments.index'
import { Route as AppMediaIndexRouteImport } from './routes/_app.media.index'
import { Route as AppIccComplaintsIndexRouteImport } from './routes/_app.icc-complaints.index'
import { Route as AppGalleryIndexRouteImport } from './routes/_app.gallery.index'
import { Route as AppEventsIndexRouteImport } from './routes/_app.events.index'
import { Route as AppEnquiriesIndexRouteImport } from './routes/_app.enquiries.index'
import { Route as AppDocumentsIndexRouteImport } from './routes/_app.documents.index'
import { Route as AppAuditLogIndexRouteImport } from './routes/_app.audit-log.index'
import { Route as AppIccComplaintsIdRouteImport } from './routes/_app.icc-complaints.$id'
import { Route as AppGalleryNewRouteImport } from './routes/_app.gallery.new'
import { Route as AppGalleryIdRouteImport } from './routes/_app.gallery.$id'
import { Route as AppEventsNewRouteImport } from './routes/_app.events.new'
import { Route as AppEventsIdRouteImport } from './routes/_app.events.$id'
import { Route as AppDocumentsNewRouteImport } from './routes/_app.documents.new'
import { Route as AppDocumentsIdRouteImport } from './routes/_app.documents.$id'
import { Route as AppStructureProgrammesIndexRouteImport } from './routes/_app.structure.programmes.index'
import { Route as AppStructureDepartmentsIndexRouteImport } from './routes/_app.structure.departments.index'
import { Route as AppDepartmentsTestimonialsIndexRouteImport } from './routes/_app.departments.testimonials.index'
import { Route as AppDepartmentsTabsIndexRouteImport } from './routes/_app.departments.tabs.index'
import { Route as AppDepartmentsResearchIndexRouteImport } from './routes/_app.departments.research.index'
import { Route as AppDepartmentsRegulationsIndexRouteImport } from './routes/_app.departments.regulations.index'
import { Route as AppDepartmentsPublicationsIndexRouteImport } from './routes/_app.departments.publications.index'
import { Route as AppDepartmentsPlacementsIndexRouteImport } from './routes/_app.departments.placements.index'
import { Route as AppDepartmentsPedagogyIndexRouteImport } from './routes/_app.departments.pedagogy.index'
import { Route as AppDepartmentsOverviewsIndexRouteImport } from './routes/_app.departments.overviews.index'
import { Route as AppDepartmentsNptelIndexRouteImport } from './routes/_app.departments.nptel.index'
import { Route as AppDepartmentsMenusIndexRouteImport } from './routes/_app.departments.menus.index'
import { Route as AppDepartmentsLabsIndexRouteImport } from './routes/_app.departments.labs.index'
import { Route as AppDepartmentsInternshipsIndexRouteImport } from './routes/_app.departments.internships.index'
import { Route as AppDepartmentsGraduationIndexRouteImport } from './routes/_app.departments.graduation.index'
import { Route as AppDepartmentsFaqsIndexRouteImport } from './routes/_app.departments.faqs.index'
import { Route as AppDepartmentsFacultyIndexRouteImport } from './routes/_app.departments.faculty.index'
import { Route as AppDepartmentsFacilitiesIndexRouteImport } from './routes/_app.departments.facilities.index'
import { Route as AppDepartmentsEContentsIndexRouteImport } from './routes/_app.departments.e-contents.index'
import { Route as AppDepartmentsCurriculumIndexRouteImport } from './routes/_app.departments.curriculum.index'
import { Route as AppDepartmentsCurriculumHighlightsIndexRouteImport } from './routes/_app.departments.curriculum-highlights.index'
import { Route as AppDepartmentsAchievementsIndexRouteImport } from './routes/_app.departments.achievements.index'
import { Route as AppContentPagesIndexRouteImport } from './routes/_app.content.pages.index'
import { Route as AppContentNewsIndexRouteImport } from './routes/_app.content.news.index'
import { Route as AppContentBlogIndexRouteImport } from './routes/_app.content.blog.index'
import { Route as AppContentAnnouncementsIndexRouteImport } from './routes/_app.content.announcements.index'
import { Route as AppCoeUpdatesIndexRouteImport } from './routes/_app.coe.updates.index'
import { Route as AppCoeDocumentsIndexRouteImport } from './routes/_app.coe.documents.index'
import { Route as AppChatbotKnowledgeBaseIndexRouteImport } from './routes/_app.chatbot.knowledge-base.index'
import { Route as AppChatbotFlaggedIndexRouteImport } from './routes/_app.chatbot.flagged.index'
import { Route as AppChatbotConversationsIndexRouteImport } from './routes/_app.chatbot.conversations.index'
import { Route as AppStructureProgrammesNewRouteImport } from './routes/_app.structure.programmes.new'
import { Route as AppStructureProgrammesIdRouteImport } from './routes/_app.structure.programmes.$id'
import { Route as AppStructureDepartmentsNewRouteImport } from './routes/_app.structure.departments.new'
import { Route as AppStructureDepartmentsIdRouteImport } from './routes/_app.structure.departments.$id'
import { Route as AppEventsIdRegistrationsRouteImport } from './routes/_app.events.$id.registrations'
import { Route as AppDepartmentsTestimonialsNewRouteImport } from './routes/_app.departments.testimonials.new'
import { Route as AppDepartmentsTestimonialsIdRouteImport } from './routes/_app.departments.testimonials.$id'
import { Route as AppDepartmentsTabsNewRouteImport } from './routes/_app.departments.tabs.new'
import { Route as AppDepartmentsTabsIdRouteImport } from './routes/_app.departments.tabs.$id'
import { Route as AppDepartmentsResearchNewRouteImport } from './routes/_app.departments.research.new'
import { Route as AppDepartmentsResearchIdRouteImport } from './routes/_app.departments.research.$id'
import { Route as AppDepartmentsRegulationsNewRouteImport } from './routes/_app.departments.regulations.new'
import { Route as AppDepartmentsRegulationsIdRouteImport } from './routes/_app.departments.regulations.$id'
import { Route as AppDepartmentsPublicationsNewRouteImport } from './routes/_app.departments.publications.new'
import { Route as AppDepartmentsPublicationsIdRouteImport } from './routes/_app.departments.publications.$id'
import { Route as AppDepartmentsPlacementsNewRouteImport } from './routes/_app.departments.placements.new'
import { Route as AppDepartmentsPlacementsIdRouteImport } from './routes/_app.departments.placements.$id'
import { Route as AppDepartmentsPedagogyNewRouteImport } from './routes/_app.departments.pedagogy.new'
import { Route as AppDepartmentsPedagogyIdRouteImport } from './routes/_app.departments.pedagogy.$id'
import { Route as AppDepartmentsOverviewsNewRouteImport } from './routes/_app.departments.overviews.new'
import { Route as AppDepartmentsOverviewsIdRouteImport } from './routes/_app.departments.overviews.$id'
import { Route as AppDepartmentsNptelNewRouteImport } from './routes/_app.departments.nptel.new'
import { Route as AppDepartmentsNptelIdRouteImport } from './routes/_app.departments.nptel.$id'
import { Route as AppDepartmentsMenusNewRouteImport } from './routes/_app.departments.menus.new'
import { Route as AppDepartmentsMenusIdRouteImport } from './routes/_app.departments.menus.$id'
import { Route as AppDepartmentsLabsNewRouteImport } from './routes/_app.departments.labs.new'
import { Route as AppDepartmentsLabsIdRouteImport } from './routes/_app.departments.labs.$id'
import { Route as AppDepartmentsInternshipsNewRouteImport } from './routes/_app.departments.internships.new'
import { Route as AppDepartmentsInternshipsIdRouteImport } from './routes/_app.departments.internships.$id'
import { Route as AppDepartmentsGraduationNewRouteImport } from './routes/_app.departments.graduation.new'
import { Route as AppDepartmentsGraduationIdRouteImport } from './routes/_app.departments.graduation.$id'
import { Route as AppDepartmentsFaqsNewRouteImport } from './routes/_app.departments.faqs.new'
import { Route as AppDepartmentsFaqsIdRouteImport } from './routes/_app.departments.faqs.$id'
import { Route as AppDepartmentsFacultyNewRouteImport } from './routes/_app.departments.faculty.new'
import { Route as AppDepartmentsFacultyIdRouteImport } from './routes/_app.departments.faculty.$id'
import { Route as AppDepartmentsFacilitiesNewRouteImport } from './routes/_app.departments.facilities.new'
import { Route as AppDepartmentsFacilitiesIdRouteImport } from './routes/_app.departments.facilities.$id'
import { Route as AppDepartmentsEContentsNewRouteImport } from './routes/_app.departments.e-contents.new'
import { Route as AppDepartmentsEContentsIdRouteImport } from './routes/_app.departments.e-contents.$id'
import { Route as AppDepartmentsCurriculumNewRouteImport } from './routes/_app.departments.curriculum.new'
import { Route as AppDepartmentsCurriculumIdRouteImport } from './routes/_app.departments.curriculum.$id'
import { Route as AppDepartmentsCurriculumHighlightsNewRouteImport } from './routes/_app.departments.curriculum-highlights.new'
import { Route as AppDepartmentsCurriculumHighlightsIdRouteImport } from './routes/_app.departments.curriculum-highlights.$id'
import { Route as AppDepartmentsAchievementsNewRouteImport } from './routes/_app.departments.achievements.new'
import { Route as AppDepartmentsAchievementsIdRouteImport } from './routes/_app.departments.achievements.$id'
import { Route as AppContentPagesNewRouteImport } from './routes/_app.content.pages.new'
import { Route as AppContentPagesIdRouteImport } from './routes/_app.content.pages.$id'
import { Route as AppContentNewsNewRouteImport } from './routes/_app.content.news.new'
import { Route as AppContentNewsIdRouteImport } from './routes/_app.content.news.$id'
import { Route as AppContentBlogNewRouteImport } from './routes/_app.content.blog.new'
import { Route as AppContentBlogIdRouteImport } from './routes/_app.content.blog.$id'
import { Route as AppCoeUpdatesNewRouteImport } from './routes/_app.coe.updates.new'
import { Route as AppCoeUpdatesIdRouteImport } from './routes/_app.coe.updates.$id'
import { Route as AppCoeDocumentsNewRouteImport } from './routes/_app.coe.documents.new'
import { Route as AppCoeDocumentsIdRouteImport } from './routes/_app.coe.documents.$id'
import { Route as AppChatbotConversationsIdRouteImport } from './routes/_app.chatbot.conversations.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRoute,
} as any)
const AppRolesIndexRoute = AppRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AppRoute,
} as any)
const AppPopupsIndexRoute = AppPopupsIndexRouteImport.update({
  id: '/popups/',
  path: '/popups/',
  getParentRoute: () => AppRoute,
} as any)
const AppPaymentsIndexRoute = AppPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => AppRoute,
} as any)
const AppMediaIndexRoute = AppMediaIndexRouteImport.update({
  id: '/media/',
  path: '/media/',
  getParentRoute: () => AppRoute,
} as any)
const AppIccComplaintsIndexRoute = AppIccComplaintsIndexRouteImport.update({
  id: '/icc-complaints/',
  path: '/icc-complaints/',
  getParentRoute: () => AppRoute,
} as any)
const AppGalleryIndexRoute = AppGalleryIndexRouteImport.update({
  id: '/gallery/',
  path: '/gallery/',
  getParentRoute: () => AppRoute,
} as any)
const AppEventsIndexRoute = AppEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => AppRoute,
} as any)
const AppEnquiriesIndexRoute = AppEnquiriesIndexRouteImport.update({
  id: '/enquiries/',
  path: '/enquiries/',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsIndexRoute = AppDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditLogIndexRoute = AppAuditLogIndexRouteImport.update({
  id: '/audit-log/',
  path: '/audit-log/',
  getParentRoute: () => AppRoute,
} as any)
const AppIccComplaintsIdRoute = AppIccComplaintsIdRouteImport.update({
  id: '/icc-complaints/$id',
  path: '/icc-complaints/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppGalleryNewRoute = AppGalleryNewRouteImport.update({
  id: '/gallery/new',
  path: '/gallery/new',
  getParentRoute: () => AppRoute,
} as any)
const AppGalleryIdRoute = AppGalleryIdRouteImport.update({
  id: '/gallery/$id',
  path: '/gallery/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppEventsNewRoute = AppEventsNewRouteImport.update({
  id: '/events/new',
  path: '/events/new',
  getParentRoute: () => AppRoute,
} as any)
const AppEventsIdRoute = AppEventsIdRouteImport.update({
  id: '/events/$id',
  path: '/events/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsNewRoute = AppDocumentsNewRouteImport.update({
  id: '/documents/new',
  path: '/documents/new',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsIdRoute = AppDocumentsIdRouteImport.update({
  id: '/documents/$id',
  path: '/documents/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppStructureProgrammesIndexRoute =
  AppStructureProgrammesIndexRouteImport.update({
    id: '/structure/programmes/',
    path: '/structure/programmes/',
    getParentRoute: () => AppRoute,
  } as any)
const AppStructureDepartmentsIndexRoute =
  AppStructureDepartmentsIndexRouteImport.update({
    id: '/structure/departments/',
    path: '/structure/departments/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsTestimonialsIndexRoute =
  AppDepartmentsTestimonialsIndexRouteImport.update({
    id: '/departments/testimonials/',
    path: '/departments/testimonials/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsTabsIndexRoute = AppDepartmentsTabsIndexRouteImport.update({
  id: '/departments/tabs/',
  path: '/departments/tabs/',
  getParentRoute: () => AppRoute,
} as any)
const AppDepartmentsResearchIndexRoute =
  AppDepartmentsResearchIndexRouteImport.update({
    id: '/departments/research/',
    path: '/departments/research/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsRegulationsIndexRoute =
  AppDepartmentsRegulationsIndexRouteImport.update({
    id: '/departments/regulations/',
    path: '/departments/regulations/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsPublicationsIndexRoute =
  AppDepartmentsPublicationsIndexRouteImport.update({
    id: '/departments/publications/',
    path: '/departments/publications/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsPlacementsIndexRoute =
  AppDepartmentsPlacementsIndexRouteImport.update({
    id: '/departments/placements/',
    path: '/departments/placements/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsPedagogyIndexRoute =
  AppDepartmentsPedagogyIndexRouteImport.update({
    id: '/departments/pedagogy/',
    path: '/departments/pedagogy/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsOverviewsIndexRoute =
  AppDepartmentsOverviewsIndexRouteImport.update({
    id: '/departments/overviews/',
    path: '/departments/overviews/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsNptelIndexRoute =
  AppDepartmentsNptelIndexRouteImport.update({
    id: '/departments/nptel/',
    path: '/departments/nptel/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsMenusIndexRoute =
  AppDepartmentsMenusIndexRouteImport.update({
    id: '/departments/menus/',
    path: '/departments/menus/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsLabsIndexRoute = AppDepartmentsLabsIndexRouteImport.update({
  id: '/departments/labs/',
  path: '/departments/labs/',
  getParentRoute: () => AppRoute,
} as any)
const AppDepartmentsInternshipsIndexRoute =
  AppDepartmentsInternshipsIndexRouteImport.update({
    id: '/departments/internships/',
    path: '/departments/internships/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsGraduationIndexRoute =
  AppDepartmentsGraduationIndexRouteImport.update({
    id: '/departments/graduation/',
    path: '/departments/graduation/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsFaqsIndexRoute = AppDepartmentsFaqsIndexRouteImport.update({
  id: '/departments/faqs/',
  path: '/departments/faqs/',
  getParentRoute: () => AppRoute,
} as any)
const AppDepartmentsFacultyIndexRoute =
  AppDepartmentsFacultyIndexRouteImport.update({
    id: '/departments/faculty/',
    path: '/departments/faculty/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsFacilitiesIndexRoute =
  AppDepartmentsFacilitiesIndexRouteImport.update({
    id: '/departments/facilities/',
    path: '/departments/facilities/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsEContentsIndexRoute =
  AppDepartmentsEContentsIndexRouteImport.update({
    id: '/departments/e-contents/',
    path: '/departments/e-contents/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsCurriculumIndexRoute =
  AppDepartmentsCurriculumIndexRouteImport.update({
    id: '/departments/curriculum/',
    path: '/departments/curriculum/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsCurriculumHighlightsIndexRoute =
  AppDepartmentsCurriculumHighlightsIndexRouteImport.update({
    id: '/departments/curriculum-highlights/',
    path: '/departments/curriculum-highlights/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsAchievementsIndexRoute =
  AppDepartmentsAchievementsIndexRouteImport.update({
    id: '/departments/achievements/',
    path: '/departments/achievements/',
    getParentRoute: () => AppRoute,
  } as any)
const AppContentPagesIndexRoute = AppContentPagesIndexRouteImport.update({
  id: '/content/pages/',
  path: '/content/pages/',
  getParentRoute: () => AppRoute,
} as any)
const AppContentNewsIndexRoute = AppContentNewsIndexRouteImport.update({
  id: '/content/news/',
  path: '/content/news/',
  getParentRoute: () => AppRoute,
} as any)
const AppContentBlogIndexRoute = AppContentBlogIndexRouteImport.update({
  id: '/content/blog/',
  path: '/content/blog/',
  getParentRoute: () => AppRoute,
} as any)
const AppContentAnnouncementsIndexRoute =
  AppContentAnnouncementsIndexRouteImport.update({
    id: '/content/announcements/',
    path: '/content/announcements/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCoeUpdatesIndexRoute = AppCoeUpdatesIndexRouteImport.update({
  id: '/coe/updates/',
  path: '/coe/updates/',
  getParentRoute: () => AppRoute,
} as any)
const AppCoeDocumentsIndexRoute = AppCoeDocumentsIndexRouteImport.update({
  id: '/coe/documents/',
  path: '/coe/documents/',
  getParentRoute: () => AppRoute,
} as any)
const AppChatbotKnowledgeBaseIndexRoute =
  AppChatbotKnowledgeBaseIndexRouteImport.update({
    id: '/chatbot/knowledge-base/',
    path: '/chatbot/knowledge-base/',
    getParentRoute: () => AppRoute,
  } as any)
const AppChatbotFlaggedIndexRoute = AppChatbotFlaggedIndexRouteImport.update({
  id: '/chatbot/flagged/',
  path: '/chatbot/flagged/',
  getParentRoute: () => AppRoute,
} as any)
const AppChatbotConversationsIndexRoute =
  AppChatbotConversationsIndexRouteImport.update({
    id: '/chatbot/conversations/',
    path: '/chatbot/conversations/',
    getParentRoute: () => AppRoute,
  } as any)
const AppStructureProgrammesNewRoute =
  AppStructureProgrammesNewRouteImport.update({
    id: '/structure/programmes/new',
    path: '/structure/programmes/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppStructureProgrammesIdRoute =
  AppStructureProgrammesIdRouteImport.update({
    id: '/structure/programmes/$id',
    path: '/structure/programmes/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppStructureDepartmentsNewRoute =
  AppStructureDepartmentsNewRouteImport.update({
    id: '/structure/departments/new',
    path: '/structure/departments/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppStructureDepartmentsIdRoute =
  AppStructureDepartmentsIdRouteImport.update({
    id: '/structure/departments/$id',
    path: '/structure/departments/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppEventsIdRegistrationsRoute =
  AppEventsIdRegistrationsRouteImport.update({
    id: '/registrations',
    path: '/registrations',
    getParentRoute: () => AppEventsIdRoute,
  } as any)
const AppDepartmentsTestimonialsNewRoute =
  AppDepartmentsTestimonialsNewRouteImport.update({
    id: '/departments/testimonials/new',
    path: '/departments/testimonials/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsTestimonialsIdRoute =
  AppDepartmentsTestimonialsIdRouteImport.update({
    id: '/departments/testimonials/$id',
    path: '/departments/testimonials/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsTabsNewRoute = AppDepartmentsTabsNewRouteImport.update({
  id: '/departments/tabs/new',
  path: '/departments/tabs/new',
  getParentRoute: () => AppRoute,
} as any)
const AppDepartmentsTabsIdRoute = AppDepartmentsTabsIdRouteImport.update({
  id: '/departments/tabs/$id',
  path: '/departments/tabs/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDepartmentsResearchNewRoute =
  AppDepartmentsResearchNewRouteImport.update({
    id: '/departments/research/new',
    path: '/departments/research/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsResearchIdRoute =
  AppDepartmentsResearchIdRouteImport.update({
    id: '/departments/research/$id',
    path: '/departments/research/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsRegulationsNewRoute =
  AppDepartmentsRegulationsNewRouteImport.update({
    id: '/departments/regulations/new',
    path: '/departments/regulations/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsRegulationsIdRoute =
  AppDepartmentsRegulationsIdRouteImport.update({
    id: '/departments/regulations/$id',
    path: '/departments/regulations/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsPublicationsNewRoute =
  AppDepartmentsPublicationsNewRouteImport.update({
    id: '/departments/publications/new',
    path: '/departments/publications/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsPublicationsIdRoute =
  AppDepartmentsPublicationsIdRouteImport.update({
    id: '/departments/publications/$id',
    path: '/departments/publications/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsPlacementsNewRoute =
  AppDepartmentsPlacementsNewRouteImport.update({
    id: '/departments/placements/new',
    path: '/departments/placements/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsPlacementsIdRoute =
  AppDepartmentsPlacementsIdRouteImport.update({
    id: '/departments/placements/$id',
    path: '/departments/placements/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsPedagogyNewRoute =
  AppDepartmentsPedagogyNewRouteImport.update({
    id: '/departments/pedagogy/new',
    path: '/departments/pedagogy/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsPedagogyIdRoute =
  AppDepartmentsPedagogyIdRouteImport.update({
    id: '/departments/pedagogy/$id',
    path: '/departments/pedagogy/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsOverviewsNewRoute =
  AppDepartmentsOverviewsNewRouteImport.update({
    id: '/departments/overviews/new',
    path: '/departments/overviews/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsOverviewsIdRoute =
  AppDepartmentsOverviewsIdRouteImport.update({
    id: '/departments/overviews/$id',
    path: '/departments/overviews/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsNptelNewRoute = AppDepartmentsNptelNewRouteImport.update({
  id: '/departments/nptel/new',
  path: '/departments/nptel/new',
  getParentRoute: () => AppRoute,
} as any)
const AppDepartmentsNptelIdRoute = AppDepartmentsNptelIdRouteImport.update({
  id: '/departments/nptel/$id',
  path: '/departments/nptel/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDepartmentsMenusNewRoute = AppDepartmentsMenusNewRouteImport.update({
  id: '/departments/menus/new',
  path: '/departments/menus/new',
  getParentRoute: () => AppRoute,
} as any)
const AppDepartmentsMenusIdRoute = AppDepartmentsMenusIdRouteImport.update({
  id: '/departments/menus/$id',
  path: '/departments/menus/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDepartmentsLabsNewRoute = AppDepartmentsLabsNewRouteImport.update({
  id: '/departments/labs/new',
  path: '/departments/labs/new',
  getParentRoute: () => AppRoute,
} as any)
const AppDepartmentsLabsIdRoute = AppDepartmentsLabsIdRouteImport.update({
  id: '/departments/labs/$id',
  path: '/departments/labs/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDepartmentsInternshipsNewRoute =
  AppDepartmentsInternshipsNewRouteImport.update({
    id: '/departments/internships/new',
    path: '/departments/internships/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsInternshipsIdRoute =
  AppDepartmentsInternshipsIdRouteImport.update({
    id: '/departments/internships/$id',
    path: '/departments/internships/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsGraduationNewRoute =
  AppDepartmentsGraduationNewRouteImport.update({
    id: '/departments/graduation/new',
    path: '/departments/graduation/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsGraduationIdRoute =
  AppDepartmentsGraduationIdRouteImport.update({
    id: '/departments/graduation/$id',
    path: '/departments/graduation/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsFaqsNewRoute = AppDepartmentsFaqsNewRouteImport.update({
  id: '/departments/faqs/new',
  path: '/departments/faqs/new',
  getParentRoute: () => AppRoute,
} as any)
const AppDepartmentsFaqsIdRoute = AppDepartmentsFaqsIdRouteImport.update({
  id: '/departments/faqs/$id',
  path: '/departments/faqs/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDepartmentsFacultyNewRoute =
  AppDepartmentsFacultyNewRouteImport.update({
    id: '/departments/faculty/new',
    path: '/departments/faculty/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsFacultyIdRoute = AppDepartmentsFacultyIdRouteImport.update({
  id: '/departments/faculty/$id',
  path: '/departments/faculty/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDepartmentsFacilitiesNewRoute =
  AppDepartmentsFacilitiesNewRouteImport.update({
    id: '/departments/facilities/new',
    path: '/departments/facilities/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsFacilitiesIdRoute =
  AppDepartmentsFacilitiesIdRouteImport.update({
    id: '/departments/facilities/$id',
    path: '/departments/facilities/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsEContentsNewRoute =
  AppDepartmentsEContentsNewRouteImport.update({
    id: '/departments/e-contents/new',
    path: '/departments/e-contents/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsEContentsIdRoute =
  AppDepartmentsEContentsIdRouteImport.update({
    id: '/departments/e-contents/$id',
    path: '/departments/e-contents/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsCurriculumNewRoute =
  AppDepartmentsCurriculumNewRouteImport.update({
    id: '/departments/curriculum/new',
    path: '/departments/curriculum/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsCurriculumIdRoute =
  AppDepartmentsCurriculumIdRouteImport.update({
    id: '/departments/curriculum/$id',
    path: '/departments/curriculum/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsCurriculumHighlightsNewRoute =
  AppDepartmentsCurriculumHighlightsNewRouteImport.update({
    id: '/departments/curriculum-highlights/new',
    path: '/departments/curriculum-highlights/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsCurriculumHighlightsIdRoute =
  AppDepartmentsCurriculumHighlightsIdRouteImport.update({
    id: '/departments/curriculum-highlights/$id',
    path: '/departments/curriculum-highlights/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsAchievementsNewRoute =
  AppDepartmentsAchievementsNewRouteImport.update({
    id: '/departments/achievements/new',
    path: '/departments/achievements/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppDepartmentsAchievementsIdRoute =
  AppDepartmentsAchievementsIdRouteImport.update({
    id: '/departments/achievements/$id',
    path: '/departments/achievements/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppContentPagesNewRoute = AppContentPagesNewRouteImport.update({
  id: '/content/pages/new',
  path: '/content/pages/new',
  getParentRoute: () => AppRoute,
} as any)
const AppContentPagesIdRoute = AppContentPagesIdRouteImport.update({
  id: '/content/pages/$id',
  path: '/content/pages/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppContentNewsNewRoute = AppContentNewsNewRouteImport.update({
  id: '/content/news/new',
  path: '/content/news/new',
  getParentRoute: () => AppRoute,
} as any)
const AppContentNewsIdRoute = AppContentNewsIdRouteImport.update({
  id: '/content/news/$id',
  path: '/content/news/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppContentBlogNewRoute = AppContentBlogNewRouteImport.update({
  id: '/content/blog/new',
  path: '/content/blog/new',
  getParentRoute: () => AppRoute,
} as any)
const AppContentBlogIdRoute = AppContentBlogIdRouteImport.update({
  id: '/content/blog/$id',
  path: '/content/blog/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCoeUpdatesNewRoute = AppCoeUpdatesNewRouteImport.update({
  id: '/coe/updates/new',
  path: '/coe/updates/new',
  getParentRoute: () => AppRoute,
} as any)
const AppCoeUpdatesIdRoute = AppCoeUpdatesIdRouteImport.update({
  id: '/coe/updates/$id',
  path: '/coe/updates/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppCoeDocumentsNewRoute = AppCoeDocumentsNewRouteImport.update({
  id: '/coe/documents/new',
  path: '/coe/documents/new',
  getParentRoute: () => AppRoute,
} as any)
const AppCoeDocumentsIdRoute = AppCoeDocumentsIdRouteImport.update({
  id: '/coe/documents/$id',
  path: '/coe/documents/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppChatbotConversationsIdRoute =
  AppChatbotConversationsIdRouteImport.update({
    id: '/chatbot/conversations/$id',
    path: '/chatbot/conversations/$id',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/documents/$id': typeof AppDocumentsIdRoute
  '/documents/new': typeof AppDocumentsNewRoute
  '/events/$id': typeof AppEventsIdRouteWithChildren
  '/events/new': typeof AppEventsNewRoute
  '/gallery/$id': typeof AppGalleryIdRoute
  '/gallery/new': typeof AppGalleryNewRoute
  '/icc-complaints/$id': typeof AppIccComplaintsIdRoute
  '/audit-log/': typeof AppAuditLogIndexRoute
  '/documents/': typeof AppDocumentsIndexRoute
  '/enquiries/': typeof AppEnquiriesIndexRoute
  '/events/': typeof AppEventsIndexRoute
  '/gallery/': typeof AppGalleryIndexRoute
  '/icc-complaints/': typeof AppIccComplaintsIndexRoute
  '/media/': typeof AppMediaIndexRoute
  '/payments/': typeof AppPaymentsIndexRoute
  '/popups/': typeof AppPopupsIndexRoute
  '/roles/': typeof AppRolesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/chatbot/conversations/$id': typeof AppChatbotConversationsIdRoute
  '/coe/documents/$id': typeof AppCoeDocumentsIdRoute
  '/coe/documents/new': typeof AppCoeDocumentsNewRoute
  '/coe/updates/$id': typeof AppCoeUpdatesIdRoute
  '/coe/updates/new': typeof AppCoeUpdatesNewRoute
  '/content/blog/$id': typeof AppContentBlogIdRoute
  '/content/blog/new': typeof AppContentBlogNewRoute
  '/content/news/$id': typeof AppContentNewsIdRoute
  '/content/news/new': typeof AppContentNewsNewRoute
  '/content/pages/$id': typeof AppContentPagesIdRoute
  '/content/pages/new': typeof AppContentPagesNewRoute
  '/departments/achievements/$id': typeof AppDepartmentsAchievementsIdRoute
  '/departments/achievements/new': typeof AppDepartmentsAchievementsNewRoute
  '/departments/curriculum-highlights/$id': typeof AppDepartmentsCurriculumHighlightsIdRoute
  '/departments/curriculum-highlights/new': typeof AppDepartmentsCurriculumHighlightsNewRoute
  '/departments/curriculum/$id': typeof AppDepartmentsCurriculumIdRoute
  '/departments/curriculum/new': typeof AppDepartmentsCurriculumNewRoute
  '/departments/e-contents/$id': typeof AppDepartmentsEContentsIdRoute
  '/departments/e-contents/new': typeof AppDepartmentsEContentsNewRoute
  '/departments/facilities/$id': typeof AppDepartmentsFacilitiesIdRoute
  '/departments/facilities/new': typeof AppDepartmentsFacilitiesNewRoute
  '/departments/faculty/$id': typeof AppDepartmentsFacultyIdRoute
  '/departments/faculty/new': typeof AppDepartmentsFacultyNewRoute
  '/departments/faqs/$id': typeof AppDepartmentsFaqsIdRoute
  '/departments/faqs/new': typeof AppDepartmentsFaqsNewRoute
  '/departments/graduation/$id': typeof AppDepartmentsGraduationIdRoute
  '/departments/graduation/new': typeof AppDepartmentsGraduationNewRoute
  '/departments/internships/$id': typeof AppDepartmentsInternshipsIdRoute
  '/departments/internships/new': typeof AppDepartmentsInternshipsNewRoute
  '/departments/labs/$id': typeof AppDepartmentsLabsIdRoute
  '/departments/labs/new': typeof AppDepartmentsLabsNewRoute
  '/departments/menus/$id': typeof AppDepartmentsMenusIdRoute
  '/departments/menus/new': typeof AppDepartmentsMenusNewRoute
  '/departments/nptel/$id': typeof AppDepartmentsNptelIdRoute
  '/departments/nptel/new': typeof AppDepartmentsNptelNewRoute
  '/departments/overviews/$id': typeof AppDepartmentsOverviewsIdRoute
  '/departments/overviews/new': typeof AppDepartmentsOverviewsNewRoute
  '/departments/pedagogy/$id': typeof AppDepartmentsPedagogyIdRoute
  '/departments/pedagogy/new': typeof AppDepartmentsPedagogyNewRoute
  '/departments/placements/$id': typeof AppDepartmentsPlacementsIdRoute
  '/departments/placements/new': typeof AppDepartmentsPlacementsNewRoute
  '/departments/publications/$id': typeof AppDepartmentsPublicationsIdRoute
  '/departments/publications/new': typeof AppDepartmentsPublicationsNewRoute
  '/departments/regulations/$id': typeof AppDepartmentsRegulationsIdRoute
  '/departments/regulations/new': typeof AppDepartmentsRegulationsNewRoute
  '/departments/research/$id': typeof AppDepartmentsResearchIdRoute
  '/departments/research/new': typeof AppDepartmentsResearchNewRoute
  '/departments/tabs/$id': typeof AppDepartmentsTabsIdRoute
  '/departments/tabs/new': typeof AppDepartmentsTabsNewRoute
  '/departments/testimonials/$id': typeof AppDepartmentsTestimonialsIdRoute
  '/departments/testimonials/new': typeof AppDepartmentsTestimonialsNewRoute
  '/events/$id/registrations': typeof AppEventsIdRegistrationsRoute
  '/structure/departments/$id': typeof AppStructureDepartmentsIdRoute
  '/structure/departments/new': typeof AppStructureDepartmentsNewRoute
  '/structure/programmes/$id': typeof AppStructureProgrammesIdRoute
  '/structure/programmes/new': typeof AppStructureProgrammesNewRoute
  '/chatbot/conversations/': typeof AppChatbotConversationsIndexRoute
  '/chatbot/flagged/': typeof AppChatbotFlaggedIndexRoute
  '/chatbot/knowledge-base/': typeof AppChatbotKnowledgeBaseIndexRoute
  '/coe/documents/': typeof AppCoeDocumentsIndexRoute
  '/coe/updates/': typeof AppCoeUpdatesIndexRoute
  '/content/announcements/': typeof AppContentAnnouncementsIndexRoute
  '/content/blog/': typeof AppContentBlogIndexRoute
  '/content/news/': typeof AppContentNewsIndexRoute
  '/content/pages/': typeof AppContentPagesIndexRoute
  '/departments/achievements/': typeof AppDepartmentsAchievementsIndexRoute
  '/departments/curriculum-highlights/': typeof AppDepartmentsCurriculumHighlightsIndexRoute
  '/departments/curriculum/': typeof AppDepartmentsCurriculumIndexRoute
  '/departments/e-contents/': typeof AppDepartmentsEContentsIndexRoute
  '/departments/facilities/': typeof AppDepartmentsFacilitiesIndexRoute
  '/departments/faculty/': typeof AppDepartmentsFacultyIndexRoute
  '/departments/faqs/': typeof AppDepartmentsFaqsIndexRoute
  '/departments/graduation/': typeof AppDepartmentsGraduationIndexRoute
  '/departments/internships/': typeof AppDepartmentsInternshipsIndexRoute
  '/departments/labs/': typeof AppDepartmentsLabsIndexRoute
  '/departments/menus/': typeof AppDepartmentsMenusIndexRoute
  '/departments/nptel/': typeof AppDepartmentsNptelIndexRoute
  '/departments/overviews/': typeof AppDepartmentsOverviewsIndexRoute
  '/departments/pedagogy/': typeof AppDepartmentsPedagogyIndexRoute
  '/departments/placements/': typeof AppDepartmentsPlacementsIndexRoute
  '/departments/publications/': typeof AppDepartmentsPublicationsIndexRoute
  '/departments/regulations/': typeof AppDepartmentsRegulationsIndexRoute
  '/departments/research/': typeof AppDepartmentsResearchIndexRoute
  '/departments/tabs/': typeof AppDepartmentsTabsIndexRoute
  '/departments/testimonials/': typeof AppDepartmentsTestimonialsIndexRoute
  '/structure/departments/': typeof AppStructureDepartmentsIndexRoute
  '/structure/programmes/': typeof AppStructureProgrammesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AppIndexRoute
  '/documents/$id': typeof AppDocumentsIdRoute
  '/documents/new': typeof AppDocumentsNewRoute
  '/events/$id': typeof AppEventsIdRouteWithChildren
  '/events/new': typeof AppEventsNewRoute
  '/gallery/$id': typeof AppGalleryIdRoute
  '/gallery/new': typeof AppGalleryNewRoute
  '/icc-complaints/$id': typeof AppIccComplaintsIdRoute
  '/audit-log': typeof AppAuditLogIndexRoute
  '/documents': typeof AppDocumentsIndexRoute
  '/enquiries': typeof AppEnquiriesIndexRoute
  '/events': typeof AppEventsIndexRoute
  '/gallery': typeof AppGalleryIndexRoute
  '/icc-complaints': typeof AppIccComplaintsIndexRoute
  '/media': typeof AppMediaIndexRoute
  '/payments': typeof AppPaymentsIndexRoute
  '/popups': typeof AppPopupsIndexRoute
  '/roles': typeof AppRolesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/chatbot/conversations/$id': typeof AppChatbotConversationsIdRoute
  '/coe/documents/$id': typeof AppCoeDocumentsIdRoute
  '/coe/documents/new': typeof AppCoeDocumentsNewRoute
  '/coe/updates/$id': typeof AppCoeUpdatesIdRoute
  '/coe/updates/new': typeof AppCoeUpdatesNewRoute
  '/content/blog/$id': typeof AppContentBlogIdRoute
  '/content/blog/new': typeof AppContentBlogNewRoute
  '/content/news/$id': typeof AppContentNewsIdRoute
  '/content/news/new': typeof AppContentNewsNewRoute
  '/content/pages/$id': typeof AppContentPagesIdRoute
  '/content/pages/new': typeof AppContentPagesNewRoute
  '/departments/achievements/$id': typeof AppDepartmentsAchievementsIdRoute
  '/departments/achievements/new': typeof AppDepartmentsAchievementsNewRoute
  '/departments/curriculum-highlights/$id': typeof AppDepartmentsCurriculumHighlightsIdRoute
  '/departments/curriculum-highlights/new': typeof AppDepartmentsCurriculumHighlightsNewRoute
  '/departments/curriculum/$id': typeof AppDepartmentsCurriculumIdRoute
  '/departments/curriculum/new': typeof AppDepartmentsCurriculumNewRoute
  '/departments/e-contents/$id': typeof AppDepartmentsEContentsIdRoute
  '/departments/e-contents/new': typeof AppDepartmentsEContentsNewRoute
  '/departments/facilities/$id': typeof AppDepartmentsFacilitiesIdRoute
  '/departments/facilities/new': typeof AppDepartmentsFacilitiesNewRoute
  '/departments/faculty/$id': typeof AppDepartmentsFacultyIdRoute
  '/departments/faculty/new': typeof AppDepartmentsFacultyNewRoute
  '/departments/faqs/$id': typeof AppDepartmentsFaqsIdRoute
  '/departments/faqs/new': typeof AppDepartmentsFaqsNewRoute
  '/departments/graduation/$id': typeof AppDepartmentsGraduationIdRoute
  '/departments/graduation/new': typeof AppDepartmentsGraduationNewRoute
  '/departments/internships/$id': typeof AppDepartmentsInternshipsIdRoute
  '/departments/internships/new': typeof AppDepartmentsInternshipsNewRoute
  '/departments/labs/$id': typeof AppDepartmentsLabsIdRoute
  '/departments/labs/new': typeof AppDepartmentsLabsNewRoute
  '/departments/menus/$id': typeof AppDepartmentsMenusIdRoute
  '/departments/menus/new': typeof AppDepartmentsMenusNewRoute
  '/departments/nptel/$id': typeof AppDepartmentsNptelIdRoute
  '/departments/nptel/new': typeof AppDepartmentsNptelNewRoute
  '/departments/overviews/$id': typeof AppDepartmentsOverviewsIdRoute
  '/departments/overviews/new': typeof AppDepartmentsOverviewsNewRoute
  '/departments/pedagogy/$id': typeof AppDepartmentsPedagogyIdRoute
  '/departments/pedagogy/new': typeof AppDepartmentsPedagogyNewRoute
  '/departments/placements/$id': typeof AppDepartmentsPlacementsIdRoute
  '/departments/placements/new': typeof AppDepartmentsPlacementsNewRoute
  '/departments/publications/$id': typeof AppDepartmentsPublicationsIdRoute
  '/departments/publications/new': typeof AppDepartmentsPublicationsNewRoute
  '/departments/regulations/$id': typeof AppDepartmentsRegulationsIdRoute
  '/departments/regulations/new': typeof AppDepartmentsRegulationsNewRoute
  '/departments/research/$id': typeof AppDepartmentsResearchIdRoute
  '/departments/research/new': typeof AppDepartmentsResearchNewRoute
  '/departments/tabs/$id': typeof AppDepartmentsTabsIdRoute
  '/departments/tabs/new': typeof AppDepartmentsTabsNewRoute
  '/departments/testimonials/$id': typeof AppDepartmentsTestimonialsIdRoute
  '/departments/testimonials/new': typeof AppDepartmentsTestimonialsNewRoute
  '/events/$id/registrations': typeof AppEventsIdRegistrationsRoute
  '/structure/departments/$id': typeof AppStructureDepartmentsIdRoute
  '/structure/departments/new': typeof AppStructureDepartmentsNewRoute
  '/structure/programmes/$id': typeof AppStructureProgrammesIdRoute
  '/structure/programmes/new': typeof AppStructureProgrammesNewRoute
  '/chatbot/conversations': typeof AppChatbotConversationsIndexRoute
  '/chatbot/flagged': typeof AppChatbotFlaggedIndexRoute
  '/chatbot/knowledge-base': typeof AppChatbotKnowledgeBaseIndexRoute
  '/coe/documents': typeof AppCoeDocumentsIndexRoute
  '/coe/updates': typeof AppCoeUpdatesIndexRoute
  '/content/announcements': typeof AppContentAnnouncementsIndexRoute
  '/content/blog': typeof AppContentBlogIndexRoute
  '/content/news': typeof AppContentNewsIndexRoute
  '/content/pages': typeof AppContentPagesIndexRoute
  '/departments/achievements': typeof AppDepartmentsAchievementsIndexRoute
  '/departments/curriculum-highlights': typeof AppDepartmentsCurriculumHighlightsIndexRoute
  '/departments/curriculum': typeof AppDepartmentsCurriculumIndexRoute
  '/departments/e-contents': typeof AppDepartmentsEContentsIndexRoute
  '/departments/facilities': typeof AppDepartmentsFacilitiesIndexRoute
  '/departments/faculty': typeof AppDepartmentsFacultyIndexRoute
  '/departments/faqs': typeof AppDepartmentsFaqsIndexRoute
  '/departments/graduation': typeof AppDepartmentsGraduationIndexRoute
  '/departments/internships': typeof AppDepartmentsInternshipsIndexRoute
  '/departments/labs': typeof AppDepartmentsLabsIndexRoute
  '/departments/menus': typeof AppDepartmentsMenusIndexRoute
  '/departments/nptel': typeof AppDepartmentsNptelIndexRoute
  '/departments/overviews': typeof AppDepartmentsOverviewsIndexRoute
  '/departments/pedagogy': typeof AppDepartmentsPedagogyIndexRoute
  '/departments/placements': typeof AppDepartmentsPlacementsIndexRoute
  '/departments/publications': typeof AppDepartmentsPublicationsIndexRoute
  '/departments/regulations': typeof AppDepartmentsRegulationsIndexRoute
  '/departments/research': typeof AppDepartmentsResearchIndexRoute
  '/departments/tabs': typeof AppDepartmentsTabsIndexRoute
  '/departments/testimonials': typeof AppDepartmentsTestimonialsIndexRoute
  '/structure/departments': typeof AppStructureDepartmentsIndexRoute
  '/structure/programmes': typeof AppStructureProgrammesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/': typeof AppIndexRoute
  '/_app/documents/$id': typeof AppDocumentsIdRoute
  '/_app/documents/new': typeof AppDocumentsNewRoute
  '/_app/events/$id': typeof AppEventsIdRouteWithChildren
  '/_app/events/new': typeof AppEventsNewRoute
  '/_app/gallery/$id': typeof AppGalleryIdRoute
  '/_app/gallery/new': typeof AppGalleryNewRoute
  '/_app/icc-complaints/$id': typeof AppIccComplaintsIdRoute
  '/_app/audit-log/': typeof AppAuditLogIndexRoute
  '/_app/documents/': typeof AppDocumentsIndexRoute
  '/_app/enquiries/': typeof AppEnquiriesIndexRoute
  '/_app/events/': typeof AppEventsIndexRoute
  '/_app/gallery/': typeof AppGalleryIndexRoute
  '/_app/icc-complaints/': typeof AppIccComplaintsIndexRoute
  '/_app/media/': typeof AppMediaIndexRoute
  '/_app/payments/': typeof AppPaymentsIndexRoute
  '/_app/popups/': typeof AppPopupsIndexRoute
  '/_app/roles/': typeof AppRolesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/chatbot/conversations/$id': typeof AppChatbotConversationsIdRoute
  '/_app/coe/documents/$id': typeof AppCoeDocumentsIdRoute
  '/_app/coe/documents/new': typeof AppCoeDocumentsNewRoute
  '/_app/coe/updates/$id': typeof AppCoeUpdatesIdRoute
  '/_app/coe/updates/new': typeof AppCoeUpdatesNewRoute
  '/_app/content/blog/$id': typeof AppContentBlogIdRoute
  '/_app/content/blog/new': typeof AppContentBlogNewRoute
  '/_app/content/news/$id': typeof AppContentNewsIdRoute
  '/_app/content/news/new': typeof AppContentNewsNewRoute
  '/_app/content/pages/$id': typeof AppContentPagesIdRoute
  '/_app/content/pages/new': typeof AppContentPagesNewRoute
  '/_app/departments/achievements/$id': typeof AppDepartmentsAchievementsIdRoute
  '/_app/departments/achievements/new': typeof AppDepartmentsAchievementsNewRoute
  '/_app/departments/curriculum-highlights/$id': typeof AppDepartmentsCurriculumHighlightsIdRoute
  '/_app/departments/curriculum-highlights/new': typeof AppDepartmentsCurriculumHighlightsNewRoute
  '/_app/departments/curriculum/$id': typeof AppDepartmentsCurriculumIdRoute
  '/_app/departments/curriculum/new': typeof AppDepartmentsCurriculumNewRoute
  '/_app/departments/e-contents/$id': typeof AppDepartmentsEContentsIdRoute
  '/_app/departments/e-contents/new': typeof AppDepartmentsEContentsNewRoute
  '/_app/departments/facilities/$id': typeof AppDepartmentsFacilitiesIdRoute
  '/_app/departments/facilities/new': typeof AppDepartmentsFacilitiesNewRoute
  '/_app/departments/faculty/$id': typeof AppDepartmentsFacultyIdRoute
  '/_app/departments/faculty/new': typeof AppDepartmentsFacultyNewRoute
  '/_app/departments/faqs/$id': typeof AppDepartmentsFaqsIdRoute
  '/_app/departments/faqs/new': typeof AppDepartmentsFaqsNewRoute
  '/_app/departments/graduation/$id': typeof AppDepartmentsGraduationIdRoute
  '/_app/departments/graduation/new': typeof AppDepartmentsGraduationNewRoute
  '/_app/departments/internships/$id': typeof AppDepartmentsInternshipsIdRoute
  '/_app/departments/internships/new': typeof AppDepartmentsInternshipsNewRoute
  '/_app/departments/labs/$id': typeof AppDepartmentsLabsIdRoute
  '/_app/departments/labs/new': typeof AppDepartmentsLabsNewRoute
  '/_app/departments/menus/$id': typeof AppDepartmentsMenusIdRoute
  '/_app/departments/menus/new': typeof AppDepartmentsMenusNewRoute
  '/_app/departments/nptel/$id': typeof AppDepartmentsNptelIdRoute
  '/_app/departments/nptel/new': typeof AppDepartmentsNptelNewRoute
  '/_app/departments/overviews/$id': typeof AppDepartmentsOverviewsIdRoute
  '/_app/departments/overviews/new': typeof AppDepartmentsOverviewsNewRoute
  '/_app/departments/pedagogy/$id': typeof AppDepartmentsPedagogyIdRoute
  '/_app/departments/pedagogy/new': typeof AppDepartmentsPedagogyNewRoute
  '/_app/departments/placements/$id': typeof AppDepartmentsPlacementsIdRoute
  '/_app/departments/placements/new': typeof AppDepartmentsPlacementsNewRoute
  '/_app/departments/publications/$id': typeof AppDepartmentsPublicationsIdRoute
  '/_app/departments/publications/new': typeof AppDepartmentsPublicationsNewRoute
  '/_app/departments/regulations/$id': typeof AppDepartmentsRegulationsIdRoute
  '/_app/departments/regulations/new': typeof AppDepartmentsRegulationsNewRoute
  '/_app/departments/research/$id': typeof AppDepartmentsResearchIdRoute
  '/_app/departments/research/new': typeof AppDepartmentsResearchNewRoute
  '/_app/departments/tabs/$id': typeof AppDepartmentsTabsIdRoute
  '/_app/departments/tabs/new': typeof AppDepartmentsTabsNewRoute
  '/_app/departments/testimonials/$id': typeof AppDepartmentsTestimonialsIdRoute
  '/_app/departments/testimonials/new': typeof AppDepartmentsTestimonialsNewRoute
  '/_app/events/$id/registrations': typeof AppEventsIdRegistrationsRoute
  '/_app/structure/departments/$id': typeof AppStructureDepartmentsIdRoute
  '/_app/structure/departments/new': typeof AppStructureDepartmentsNewRoute
  '/_app/structure/programmes/$id': typeof AppStructureProgrammesIdRoute
  '/_app/structure/programmes/new': typeof AppStructureProgrammesNewRoute
  '/_app/chatbot/conversations/': typeof AppChatbotConversationsIndexRoute
  '/_app/chatbot/flagged/': typeof AppChatbotFlaggedIndexRoute
  '/_app/chatbot/knowledge-base/': typeof AppChatbotKnowledgeBaseIndexRoute
  '/_app/coe/documents/': typeof AppCoeDocumentsIndexRoute
  '/_app/coe/updates/': typeof AppCoeUpdatesIndexRoute
  '/_app/content/announcements/': typeof AppContentAnnouncementsIndexRoute
  '/_app/content/blog/': typeof AppContentBlogIndexRoute
  '/_app/content/news/': typeof AppContentNewsIndexRoute
  '/_app/content/pages/': typeof AppContentPagesIndexRoute
  '/_app/departments/achievements/': typeof AppDepartmentsAchievementsIndexRoute
  '/_app/departments/curriculum-highlights/': typeof AppDepartmentsCurriculumHighlightsIndexRoute
  '/_app/departments/curriculum/': typeof AppDepartmentsCurriculumIndexRoute
  '/_app/departments/e-contents/': typeof AppDepartmentsEContentsIndexRoute
  '/_app/departments/facilities/': typeof AppDepartmentsFacilitiesIndexRoute
  '/_app/departments/faculty/': typeof AppDepartmentsFacultyIndexRoute
  '/_app/departments/faqs/': typeof AppDepartmentsFaqsIndexRoute
  '/_app/departments/graduation/': typeof AppDepartmentsGraduationIndexRoute
  '/_app/departments/internships/': typeof AppDepartmentsInternshipsIndexRoute
  '/_app/departments/labs/': typeof AppDepartmentsLabsIndexRoute
  '/_app/departments/menus/': typeof AppDepartmentsMenusIndexRoute
  '/_app/departments/nptel/': typeof AppDepartmentsNptelIndexRoute
  '/_app/departments/overviews/': typeof AppDepartmentsOverviewsIndexRoute
  '/_app/departments/pedagogy/': typeof AppDepartmentsPedagogyIndexRoute
  '/_app/departments/placements/': typeof AppDepartmentsPlacementsIndexRoute
  '/_app/departments/publications/': typeof AppDepartmentsPublicationsIndexRoute
  '/_app/departments/regulations/': typeof AppDepartmentsRegulationsIndexRoute
  '/_app/departments/research/': typeof AppDepartmentsResearchIndexRoute
  '/_app/departments/tabs/': typeof AppDepartmentsTabsIndexRoute
  '/_app/departments/testimonials/': typeof AppDepartmentsTestimonialsIndexRoute
  '/_app/structure/departments/': typeof AppStructureDepartmentsIndexRoute
  '/_app/structure/programmes/': typeof AppStructureProgrammesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/documents/$id'
    | '/documents/new'
    | '/events/$id'
    | '/events/new'
    | '/gallery/$id'
    | '/gallery/new'
    | '/icc-complaints/$id'
    | '/audit-log/'
    | '/documents/'
    | '/enquiries/'
    | '/events/'
    | '/gallery/'
    | '/icc-complaints/'
    | '/media/'
    | '/payments/'
    | '/popups/'
    | '/roles/'
    | '/settings/'
    | '/users/'
    | '/chatbot/conversations/$id'
    | '/coe/documents/$id'
    | '/coe/documents/new'
    | '/coe/updates/$id'
    | '/coe/updates/new'
    | '/content/blog/$id'
    | '/content/blog/new'
    | '/content/news/$id'
    | '/content/news/new'
    | '/content/pages/$id'
    | '/content/pages/new'
    | '/departments/achievements/$id'
    | '/departments/achievements/new'
    | '/departments/curriculum-highlights/$id'
    | '/departments/curriculum-highlights/new'
    | '/departments/curriculum/$id'
    | '/departments/curriculum/new'
    | '/departments/e-contents/$id'
    | '/departments/e-contents/new'
    | '/departments/facilities/$id'
    | '/departments/facilities/new'
    | '/departments/faculty/$id'
    | '/departments/faculty/new'
    | '/departments/faqs/$id'
    | '/departments/faqs/new'
    | '/departments/graduation/$id'
    | '/departments/graduation/new'
    | '/departments/internships/$id'
    | '/departments/internships/new'
    | '/departments/labs/$id'
    | '/departments/labs/new'
    | '/departments/menus/$id'
    | '/departments/menus/new'
    | '/departments/nptel/$id'
    | '/departments/nptel/new'
    | '/departments/overviews/$id'
    | '/departments/overviews/new'
    | '/departments/pedagogy/$id'
    | '/departments/pedagogy/new'
    | '/departments/placements/$id'
    | '/departments/placements/new'
    | '/departments/publications/$id'
    | '/departments/publications/new'
    | '/departments/regulations/$id'
    | '/departments/regulations/new'
    | '/departments/research/$id'
    | '/departments/research/new'
    | '/departments/tabs/$id'
    | '/departments/tabs/new'
    | '/departments/testimonials/$id'
    | '/departments/testimonials/new'
    | '/events/$id/registrations'
    | '/structure/departments/$id'
    | '/structure/departments/new'
    | '/structure/programmes/$id'
    | '/structure/programmes/new'
    | '/chatbot/conversations/'
    | '/chatbot/flagged/'
    | '/chatbot/knowledge-base/'
    | '/coe/documents/'
    | '/coe/updates/'
    | '/content/announcements/'
    | '/content/blog/'
    | '/content/news/'
    | '/content/pages/'
    | '/departments/achievements/'
    | '/departments/curriculum-highlights/'
    | '/departments/curriculum/'
    | '/departments/e-contents/'
    | '/departments/facilities/'
    | '/departments/faculty/'
    | '/departments/faqs/'
    | '/departments/graduation/'
    | '/departments/internships/'
    | '/departments/labs/'
    | '/departments/menus/'
    | '/departments/nptel/'
    | '/departments/overviews/'
    | '/departments/pedagogy/'
    | '/departments/placements/'
    | '/departments/publications/'
    | '/departments/regulations/'
    | '/departments/research/'
    | '/departments/tabs/'
    | '/departments/testimonials/'
    | '/structure/departments/'
    | '/structure/programmes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/documents/$id'
    | '/documents/new'
    | '/events/$id'
    | '/events/new'
    | '/gallery/$id'
    | '/gallery/new'
    | '/icc-complaints/$id'
    | '/audit-log'
    | '/documents'
    | '/enquiries'
    | '/events'
    | '/gallery'
    | '/icc-complaints'
    | '/media'
    | '/payments'
    | '/popups'
    | '/roles'
    | '/settings'
    | '/users'
    | '/chatbot/conversations/$id'
    | '/coe/documents/$id'
    | '/coe/documents/new'
    | '/coe/updates/$id'
    | '/coe/updates/new'
    | '/content/blog/$id'
    | '/content/blog/new'
    | '/content/news/$id'
    | '/content/news/new'
    | '/content/pages/$id'
    | '/content/pages/new'
    | '/departments/achievements/$id'
    | '/departments/achievements/new'
    | '/departments/curriculum-highlights/$id'
    | '/departments/curriculum-highlights/new'
    | '/departments/curriculum/$id'
    | '/departments/curriculum/new'
    | '/departments/e-contents/$id'
    | '/departments/e-contents/new'
    | '/departments/facilities/$id'
    | '/departments/facilities/new'
    | '/departments/faculty/$id'
    | '/departments/faculty/new'
    | '/departments/faqs/$id'
    | '/departments/faqs/new'
    | '/departments/graduation/$id'
    | '/departments/graduation/new'
    | '/departments/internships/$id'
    | '/departments/internships/new'
    | '/departments/labs/$id'
    | '/departments/labs/new'
    | '/departments/menus/$id'
    | '/departments/menus/new'
    | '/departments/nptel/$id'
    | '/departments/nptel/new'
    | '/departments/overviews/$id'
    | '/departments/overviews/new'
    | '/departments/pedagogy/$id'
    | '/departments/pedagogy/new'
    | '/departments/placements/$id'
    | '/departments/placements/new'
    | '/departments/publications/$id'
    | '/departments/publications/new'
    | '/departments/regulations/$id'
    | '/departments/regulations/new'
    | '/departments/research/$id'
    | '/departments/research/new'
    | '/departments/tabs/$id'
    | '/departments/tabs/new'
    | '/departments/testimonials/$id'
    | '/departments/testimonials/new'
    | '/events/$id/registrations'
    | '/structure/departments/$id'
    | '/structure/departments/new'
    | '/structure/programmes/$id'
    | '/structure/programmes/new'
    | '/chatbot/conversations'
    | '/chatbot/flagged'
    | '/chatbot/knowledge-base'
    | '/coe/documents'
    | '/coe/updates'
    | '/content/announcements'
    | '/content/blog'
    | '/content/news'
    | '/content/pages'
    | '/departments/achievements'
    | '/departments/curriculum-highlights'
    | '/departments/curriculum'
    | '/departments/e-contents'
    | '/departments/facilities'
    | '/departments/faculty'
    | '/departments/faqs'
    | '/departments/graduation'
    | '/departments/internships'
    | '/departments/labs'
    | '/departments/menus'
    | '/departments/nptel'
    | '/departments/overviews'
    | '/departments/pedagogy'
    | '/departments/placements'
    | '/departments/publications'
    | '/departments/regulations'
    | '/departments/research'
    | '/departments/tabs'
    | '/departments/testimonials'
    | '/structure/departments'
    | '/structure/programmes'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/'
    | '/_app/documents/$id'
    | '/_app/documents/new'
    | '/_app/events/$id'
    | '/_app/events/new'
    | '/_app/gallery/$id'
    | '/_app/gallery/new'
    | '/_app/icc-complaints/$id'
    | '/_app/audit-log/'
    | '/_app/documents/'
    | '/_app/enquiries/'
    | '/_app/events/'
    | '/_app/gallery/'
    | '/_app/icc-complaints/'
    | '/_app/media/'
    | '/_app/payments/'
    | '/_app/popups/'
    | '/_app/roles/'
    | '/_app/settings/'
    | '/_app/users/'
    | '/_app/chatbot/conversations/$id'
    | '/_app/coe/documents/$id'
    | '/_app/coe/documents/new'
    | '/_app/coe/updates/$id'
    | '/_app/coe/updates/new'
    | '/_app/content/blog/$id'
    | '/_app/content/blog/new'
    | '/_app/content/news/$id'
    | '/_app/content/news/new'
    | '/_app/content/pages/$id'
    | '/_app/content/pages/new'
    | '/_app/departments/achievements/$id'
    | '/_app/departments/achievements/new'
    | '/_app/departments/curriculum-highlights/$id'
    | '/_app/departments/curriculum-highlights/new'
    | '/_app/departments/curriculum/$id'
    | '/_app/departments/curriculum/new'
    | '/_app/departments/e-contents/$id'
    | '/_app/departments/e-contents/new'
    | '/_app/departments/facilities/$id'
    | '/_app/departments/facilities/new'
    | '/_app/departments/faculty/$id'
    | '/_app/departments/faculty/new'
    | '/_app/departments/faqs/$id'
    | '/_app/departments/faqs/new'
    | '/_app/departments/graduation/$id'
    | '/_app/departments/graduation/new'
    | '/_app/departments/internships/$id'
    | '/_app/departments/internships/new'
    | '/_app/departments/labs/$id'
    | '/_app/departments/labs/new'
    | '/_app/departments/menus/$id'
    | '/_app/departments/menus/new'
    | '/_app/departments/nptel/$id'
    | '/_app/departments/nptel/new'
    | '/_app/departments/overviews/$id'
    | '/_app/departments/overviews/new'
    | '/_app/departments/pedagogy/$id'
    | '/_app/departments/pedagogy/new'
    | '/_app/departments/placements/$id'
    | '/_app/departments/placements/new'
    | '/_app/departments/publications/$id'
    | '/_app/departments/publications/new'
    | '/_app/departments/regulations/$id'
    | '/_app/departments/regulations/new'
    | '/_app/departments/research/$id'
    | '/_app/departments/research/new'
    | '/_app/departments/tabs/$id'
    | '/_app/departments/tabs/new'
    | '/_app/departments/testimonials/$id'
    | '/_app/departments/testimonials/new'
    | '/_app/events/$id/registrations'
    | '/_app/structure/departments/$id'
    | '/_app/structure/departments/new'
    | '/_app/structure/programmes/$id'
    | '/_app/structure/programmes/new'
    | '/_app/chatbot/conversations/'
    | '/_app/chatbot/flagged/'
    | '/_app/chatbot/knowledge-base/'
    | '/_app/coe/documents/'
    | '/_app/coe/updates/'
    | '/_app/content/announcements/'
    | '/_app/content/blog/'
    | '/_app/content/news/'
    | '/_app/content/pages/'
    | '/_app/departments/achievements/'
    | '/_app/departments/curriculum-highlights/'
    | '/_app/departments/curriculum/'
    | '/_app/departments/e-contents/'
    | '/_app/departments/facilities/'
    | '/_app/departments/faculty/'
    | '/_app/departments/faqs/'
    | '/_app/departments/graduation/'
    | '/_app/departments/internships/'
    | '/_app/departments/labs/'
    | '/_app/departments/menus/'
    | '/_app/departments/nptel/'
    | '/_app/departments/overviews/'
    | '/_app/departments/pedagogy/'
    | '/_app/departments/placements/'
    | '/_app/departments/publications/'
    | '/_app/departments/regulations/'
    | '/_app/departments/research/'
    | '/_app/departments/tabs/'
    | '/_app/departments/testimonials/'
    | '/_app/structure/departments/'
    | '/_app/structure/programmes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/roles/': {
      id: '/_app/roles/'
      path: '/roles'
      fullPath: '/roles/'
      preLoaderRoute: typeof AppRolesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/popups/': {
      id: '/_app/popups/'
      path: '/popups'
      fullPath: '/popups/'
      preLoaderRoute: typeof AppPopupsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payments/': {
      id: '/_app/payments/'
      path: '/payments'
      fullPath: '/payments/'
      preLoaderRoute: typeof AppPaymentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/media/': {
      id: '/_app/media/'
      path: '/media'
      fullPath: '/media/'
      preLoaderRoute: typeof AppMediaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/icc-complaints/': {
      id: '/_app/icc-complaints/'
      path: '/icc-complaints'
      fullPath: '/icc-complaints/'
      preLoaderRoute: typeof AppIccComplaintsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gallery/': {
      id: '/_app/gallery/'
      path: '/gallery'
      fullPath: '/gallery/'
      preLoaderRoute: typeof AppGalleryIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/events/': {
      id: '/_app/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof AppEventsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/enquiries/': {
      id: '/_app/enquiries/'
      path: '/enquiries'
      fullPath: '/enquiries/'
      preLoaderRoute: typeof AppEnquiriesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/': {
      id: '/_app/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof AppDocumentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit-log/': {
      id: '/_app/audit-log/'
      path: '/audit-log'
      fullPath: '/audit-log/'
      preLoaderRoute: typeof AppAuditLogIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/icc-complaints/$id': {
      id: '/_app/icc-complaints/$id'
      path: '/icc-complaints/$id'
      fullPath: '/icc-complaints/$id'
      preLoaderRoute: typeof AppIccComplaintsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gallery/new': {
      id: '/_app/gallery/new'
      path: '/gallery/new'
      fullPath: '/gallery/new'
      preLoaderRoute: typeof AppGalleryNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gallery/$id': {
      id: '/_app/gallery/$id'
      path: '/gallery/$id'
      fullPath: '/gallery/$id'
      preLoaderRoute: typeof AppGalleryIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/events/new': {
      id: '/_app/events/new'
      path: '/events/new'
      fullPath: '/events/new'
      preLoaderRoute: typeof AppEventsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/events/$id': {
      id: '/_app/events/$id'
      path: '/events/$id'
      fullPath: '/events/$id'
      preLoaderRoute: typeof AppEventsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/new': {
      id: '/_app/documents/new'
      path: '/documents/new'
      fullPath: '/documents/new'
      preLoaderRoute: typeof AppDocumentsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/$id': {
      id: '/_app/documents/$id'
      path: '/documents/$id'
      fullPath: '/documents/$id'
      preLoaderRoute: typeof AppDocumentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/structure/programmes/': {
      id: '/_app/structure/programmes/'
      path: '/structure/programmes'
      fullPath: '/structure/programmes/'
      preLoaderRoute: typeof AppStructureProgrammesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/structure/departments/': {
      id: '/_app/structure/departments/'
      path: '/structure/departments'
      fullPath: '/structure/departments/'
      preLoaderRoute: typeof AppStructureDepartmentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/testimonials/': {
      id: '/_app/departments/testimonials/'
      path: '/departments/testimonials'
      fullPath: '/departments/testimonials/'
      preLoaderRoute: typeof AppDepartmentsTestimonialsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/tabs/': {
      id: '/_app/departments/tabs/'
      path: '/departments/tabs'
      fullPath: '/departments/tabs/'
      preLoaderRoute: typeof AppDepartmentsTabsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/research/': {
      id: '/_app/departments/research/'
      path: '/departments/research'
      fullPath: '/departments/research/'
      preLoaderRoute: typeof AppDepartmentsResearchIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/regulations/': {
      id: '/_app/departments/regulations/'
      path: '/departments/regulations'
      fullPath: '/departments/regulations/'
      preLoaderRoute: typeof AppDepartmentsRegulationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/publications/': {
      id: '/_app/departments/publications/'
      path: '/departments/publications'
      fullPath: '/departments/publications/'
      preLoaderRoute: typeof AppDepartmentsPublicationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/placements/': {
      id: '/_app/departments/placements/'
      path: '/departments/placements'
      fullPath: '/departments/placements/'
      preLoaderRoute: typeof AppDepartmentsPlacementsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/pedagogy/': {
      id: '/_app/departments/pedagogy/'
      path: '/departments/pedagogy'
      fullPath: '/departments/pedagogy/'
      preLoaderRoute: typeof AppDepartmentsPedagogyIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/overviews/': {
      id: '/_app/departments/overviews/'
      path: '/departments/overviews'
      fullPath: '/departments/overviews/'
      preLoaderRoute: typeof AppDepartmentsOverviewsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/nptel/': {
      id: '/_app/departments/nptel/'
      path: '/departments/nptel'
      fullPath: '/departments/nptel/'
      preLoaderRoute: typeof AppDepartmentsNptelIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/menus/': {
      id: '/_app/departments/menus/'
      path: '/departments/menus'
      fullPath: '/departments/menus/'
      preLoaderRoute: typeof AppDepartmentsMenusIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/labs/': {
      id: '/_app/departments/labs/'
      path: '/departments/labs'
      fullPath: '/departments/labs/'
      preLoaderRoute: typeof AppDepartmentsLabsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/internships/': {
      id: '/_app/departments/internships/'
      path: '/departments/internships'
      fullPath: '/departments/internships/'
      preLoaderRoute: typeof AppDepartmentsInternshipsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/graduation/': {
      id: '/_app/departments/graduation/'
      path: '/departments/graduation'
      fullPath: '/departments/graduation/'
      preLoaderRoute: typeof AppDepartmentsGraduationIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/faqs/': {
      id: '/_app/departments/faqs/'
      path: '/departments/faqs'
      fullPath: '/departments/faqs/'
      preLoaderRoute: typeof AppDepartmentsFaqsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/faculty/': {
      id: '/_app/departments/faculty/'
      path: '/departments/faculty'
      fullPath: '/departments/faculty/'
      preLoaderRoute: typeof AppDepartmentsFacultyIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/facilities/': {
      id: '/_app/departments/facilities/'
      path: '/departments/facilities'
      fullPath: '/departments/facilities/'
      preLoaderRoute: typeof AppDepartmentsFacilitiesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/e-contents/': {
      id: '/_app/departments/e-contents/'
      path: '/departments/e-contents'
      fullPath: '/departments/e-contents/'
      preLoaderRoute: typeof AppDepartmentsEContentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/curriculum/': {
      id: '/_app/departments/curriculum/'
      path: '/departments/curriculum'
      fullPath: '/departments/curriculum/'
      preLoaderRoute: typeof AppDepartmentsCurriculumIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/curriculum-highlights/': {
      id: '/_app/departments/curriculum-highlights/'
      path: '/departments/curriculum-highlights'
      fullPath: '/departments/curriculum-highlights/'
      preLoaderRoute: typeof AppDepartmentsCurriculumHighlightsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/achievements/': {
      id: '/_app/departments/achievements/'
      path: '/departments/achievements'
      fullPath: '/departments/achievements/'
      preLoaderRoute: typeof AppDepartmentsAchievementsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/content/pages/': {
      id: '/_app/content/pages/'
      path: '/content/pages'
      fullPath: '/content/pages/'
      preLoaderRoute: typeof AppContentPagesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/content/news/': {
      id: '/_app/content/news/'
      path: '/content/news'
      fullPath: '/content/news/'
      preLoaderRoute: typeof AppContentNewsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/content/blog/': {
      id: '/_app/content/blog/'
      path: '/content/blog'
      fullPath: '/content/blog/'
      preLoaderRoute: typeof AppContentBlogIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/content/announcements/': {
      id: '/_app/content/announcements/'
      path: '/content/announcements'
      fullPath: '/content/announcements/'
      preLoaderRoute: typeof AppContentAnnouncementsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coe/updates/': {
      id: '/_app/coe/updates/'
      path: '/coe/updates'
      fullPath: '/coe/updates/'
      preLoaderRoute: typeof AppCoeUpdatesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coe/documents/': {
      id: '/_app/coe/documents/'
      path: '/coe/documents'
      fullPath: '/coe/documents/'
      preLoaderRoute: typeof AppCoeDocumentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chatbot/knowledge-base/': {
      id: '/_app/chatbot/knowledge-base/'
      path: '/chatbot/knowledge-base'
      fullPath: '/chatbot/knowledge-base/'
      preLoaderRoute: typeof AppChatbotKnowledgeBaseIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chatbot/flagged/': {
      id: '/_app/chatbot/flagged/'
      path: '/chatbot/flagged'
      fullPath: '/chatbot/flagged/'
      preLoaderRoute: typeof AppChatbotFlaggedIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chatbot/conversations/': {
      id: '/_app/chatbot/conversations/'
      path: '/chatbot/conversations'
      fullPath: '/chatbot/conversations/'
      preLoaderRoute: typeof AppChatbotConversationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/structure/programmes/new': {
      id: '/_app/structure/programmes/new'
      path: '/structure/programmes/new'
      fullPath: '/structure/programmes/new'
      preLoaderRoute: typeof AppStructureProgrammesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/structure/programmes/$id': {
      id: '/_app/structure/programmes/$id'
      path: '/structure/programmes/$id'
      fullPath: '/structure/programmes/$id'
      preLoaderRoute: typeof AppStructureProgrammesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/structure/departments/new': {
      id: '/_app/structure/departments/new'
      path: '/structure/departments/new'
      fullPath: '/structure/departments/new'
      preLoaderRoute: typeof AppStructureDepartmentsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/structure/departments/$id': {
      id: '/_app/structure/departments/$id'
      path: '/structure/departments/$id'
      fullPath: '/structure/departments/$id'
      preLoaderRoute: typeof AppStructureDepartmentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/events/$id/registrations': {
      id: '/_app/events/$id/registrations'
      path: '/registrations'
      fullPath: '/events/$id/registrations'
      preLoaderRoute: typeof AppEventsIdRegistrationsRouteImport
      parentRoute: typeof AppEventsIdRoute
    }
    '/_app/departments/testimonials/new': {
      id: '/_app/departments/testimonials/new'
      path: '/departments/testimonials/new'
      fullPath: '/departments/testimonials/new'
      preLoaderRoute: typeof AppDepartmentsTestimonialsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/testimonials/$id': {
      id: '/_app/departments/testimonials/$id'
      path: '/departments/testimonials/$id'
      fullPath: '/departments/testimonials/$id'
      preLoaderRoute: typeof AppDepartmentsTestimonialsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/tabs/new': {
      id: '/_app/departments/tabs/new'
      path: '/departments/tabs/new'
      fullPath: '/departments/tabs/new'
      preLoaderRoute: typeof AppDepartmentsTabsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/tabs/$id': {
      id: '/_app/departments/tabs/$id'
      path: '/departments/tabs/$id'
      fullPath: '/departments/tabs/$id'
      preLoaderRoute: typeof AppDepartmentsTabsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/research/new': {
      id: '/_app/departments/research/new'
      path: '/departments/research/new'
      fullPath: '/departments/research/new'
      preLoaderRoute: typeof AppDepartmentsResearchNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/research/$id': {
      id: '/_app/departments/research/$id'
      path: '/departments/research/$id'
      fullPath: '/departments/research/$id'
      preLoaderRoute: typeof AppDepartmentsResearchIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/regulations/new': {
      id: '/_app/departments/regulations/new'
      path: '/departments/regulations/new'
      fullPath: '/departments/regulations/new'
      preLoaderRoute: typeof AppDepartmentsRegulationsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/regulations/$id': {
      id: '/_app/departments/regulations/$id'
      path: '/departments/regulations/$id'
      fullPath: '/departments/regulations/$id'
      preLoaderRoute: typeof AppDepartmentsRegulationsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/publications/new': {
      id: '/_app/departments/publications/new'
      path: '/departments/publications/new'
      fullPath: '/departments/publications/new'
      preLoaderRoute: typeof AppDepartmentsPublicationsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/publications/$id': {
      id: '/_app/departments/publications/$id'
      path: '/departments/publications/$id'
      fullPath: '/departments/publications/$id'
      preLoaderRoute: typeof AppDepartmentsPublicationsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/placements/new': {
      id: '/_app/departments/placements/new'
      path: '/departments/placements/new'
      fullPath: '/departments/placements/new'
      preLoaderRoute: typeof AppDepartmentsPlacementsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/placements/$id': {
      id: '/_app/departments/placements/$id'
      path: '/departments/placements/$id'
      fullPath: '/departments/placements/$id'
      preLoaderRoute: typeof AppDepartmentsPlacementsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/pedagogy/new': {
      id: '/_app/departments/pedagogy/new'
      path: '/departments/pedagogy/new'
      fullPath: '/departments/pedagogy/new'
      preLoaderRoute: typeof AppDepartmentsPedagogyNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/pedagogy/$id': {
      id: '/_app/departments/pedagogy/$id'
      path: '/departments/pedagogy/$id'
      fullPath: '/departments/pedagogy/$id'
      preLoaderRoute: typeof AppDepartmentsPedagogyIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/overviews/new': {
      id: '/_app/departments/overviews/new'
      path: '/departments/overviews/new'
      fullPath: '/departments/overviews/new'
      preLoaderRoute: typeof AppDepartmentsOverviewsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/overviews/$id': {
      id: '/_app/departments/overviews/$id'
      path: '/departments/overviews/$id'
      fullPath: '/departments/overviews/$id'
      preLoaderRoute: typeof AppDepartmentsOverviewsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/nptel/new': {
      id: '/_app/departments/nptel/new'
      path: '/departments/nptel/new'
      fullPath: '/departments/nptel/new'
      preLoaderRoute: typeof AppDepartmentsNptelNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/nptel/$id': {
      id: '/_app/departments/nptel/$id'
      path: '/departments/nptel/$id'
      fullPath: '/departments/nptel/$id'
      preLoaderRoute: typeof AppDepartmentsNptelIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/menus/new': {
      id: '/_app/departments/menus/new'
      path: '/departments/menus/new'
      fullPath: '/departments/menus/new'
      preLoaderRoute: typeof AppDepartmentsMenusNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/menus/$id': {
      id: '/_app/departments/menus/$id'
      path: '/departments/menus/$id'
      fullPath: '/departments/menus/$id'
      preLoaderRoute: typeof AppDepartmentsMenusIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/labs/new': {
      id: '/_app/departments/labs/new'
      path: '/departments/labs/new'
      fullPath: '/departments/labs/new'
      preLoaderRoute: typeof AppDepartmentsLabsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/labs/$id': {
      id: '/_app/departments/labs/$id'
      path: '/departments/labs/$id'
      fullPath: '/departments/labs/$id'
      preLoaderRoute: typeof AppDepartmentsLabsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/internships/new': {
      id: '/_app/departments/internships/new'
      path: '/departments/internships/new'
      fullPath: '/departments/internships/new'
      preLoaderRoute: typeof AppDepartmentsInternshipsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/internships/$id': {
      id: '/_app/departments/internships/$id'
      path: '/departments/internships/$id'
      fullPath: '/departments/internships/$id'
      preLoaderRoute: typeof AppDepartmentsInternshipsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/graduation/new': {
      id: '/_app/departments/graduation/new'
      path: '/departments/graduation/new'
      fullPath: '/departments/graduation/new'
      preLoaderRoute: typeof AppDepartmentsGraduationNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/graduation/$id': {
      id: '/_app/departments/graduation/$id'
      path: '/departments/graduation/$id'
      fullPath: '/departments/graduation/$id'
      preLoaderRoute: typeof AppDepartmentsGraduationIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/faqs/new': {
      id: '/_app/departments/faqs/new'
      path: '/departments/faqs/new'
      fullPath: '/departments/faqs/new'
      preLoaderRoute: typeof AppDepartmentsFaqsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/faqs/$id': {
      id: '/_app/departments/faqs/$id'
      path: '/departments/faqs/$id'
      fullPath: '/departments/faqs/$id'
      preLoaderRoute: typeof AppDepartmentsFaqsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/faculty/new': {
      id: '/_app/departments/faculty/new'
      path: '/departments/faculty/new'
      fullPath: '/departments/faculty/new'
      preLoaderRoute: typeof AppDepartmentsFacultyNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/faculty/$id': {
      id: '/_app/departments/faculty/$id'
      path: '/departments/faculty/$id'
      fullPath: '/departments/faculty/$id'
      preLoaderRoute: typeof AppDepartmentsFacultyIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/facilities/new': {
      id: '/_app/departments/facilities/new'
      path: '/departments/facilities/new'
      fullPath: '/departments/facilities/new'
      preLoaderRoute: typeof AppDepartmentsFacilitiesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/facilities/$id': {
      id: '/_app/departments/facilities/$id'
      path: '/departments/facilities/$id'
      fullPath: '/departments/facilities/$id'
      preLoaderRoute: typeof AppDepartmentsFacilitiesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/e-contents/new': {
      id: '/_app/departments/e-contents/new'
      path: '/departments/e-contents/new'
      fullPath: '/departments/e-contents/new'
      preLoaderRoute: typeof AppDepartmentsEContentsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/e-contents/$id': {
      id: '/_app/departments/e-contents/$id'
      path: '/departments/e-contents/$id'
      fullPath: '/departments/e-contents/$id'
      preLoaderRoute: typeof AppDepartmentsEContentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/curriculum/new': {
      id: '/_app/departments/curriculum/new'
      path: '/departments/curriculum/new'
      fullPath: '/departments/curriculum/new'
      preLoaderRoute: typeof AppDepartmentsCurriculumNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/curriculum/$id': {
      id: '/_app/departments/curriculum/$id'
      path: '/departments/curriculum/$id'
      fullPath: '/departments/curriculum/$id'
      preLoaderRoute: typeof AppDepartmentsCurriculumIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/curriculum-highlights/new': {
      id: '/_app/departments/curriculum-highlights/new'
      path: '/departments/curriculum-highlights/new'
      fullPath: '/departments/curriculum-highlights/new'
      preLoaderRoute: typeof AppDepartmentsCurriculumHighlightsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/curriculum-highlights/$id': {
      id: '/_app/departments/curriculum-highlights/$id'
      path: '/departments/curriculum-highlights/$id'
      fullPath: '/departments/curriculum-highlights/$id'
      preLoaderRoute: typeof AppDepartmentsCurriculumHighlightsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/achievements/new': {
      id: '/_app/departments/achievements/new'
      path: '/departments/achievements/new'
      fullPath: '/departments/achievements/new'
      preLoaderRoute: typeof AppDepartmentsAchievementsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/departments/achievements/$id': {
      id: '/_app/departments/achievements/$id'
      path: '/departments/achievements/$id'
      fullPath: '/departments/achievements/$id'
      preLoaderRoute: typeof AppDepartmentsAchievementsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/content/pages/new': {
      id: '/_app/content/pages/new'
      path: '/content/pages/new'
      fullPath: '/content/pages/new'
      preLoaderRoute: typeof AppContentPagesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/content/pages/$id': {
      id: '/_app/content/pages/$id'
      path: '/content/pages/$id'
      fullPath: '/content/pages/$id'
      preLoaderRoute: typeof AppContentPagesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/content/news/new': {
      id: '/_app/content/news/new'
      path: '/content/news/new'
      fullPath: '/content/news/new'
      preLoaderRoute: typeof AppContentNewsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/content/news/$id': {
      id: '/_app/content/news/$id'
      path: '/content/news/$id'
      fullPath: '/content/news/$id'
      preLoaderRoute: typeof AppContentNewsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/content/blog/new': {
      id: '/_app/content/blog/new'
      path: '/content/blog/new'
      fullPath: '/content/blog/new'
      preLoaderRoute: typeof AppContentBlogNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/content/blog/$id': {
      id: '/_app/content/blog/$id'
      path: '/content/blog/$id'
      fullPath: '/content/blog/$id'
      preLoaderRoute: typeof AppContentBlogIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coe/updates/new': {
      id: '/_app/coe/updates/new'
      path: '/coe/updates/new'
      fullPath: '/coe/updates/new'
      preLoaderRoute: typeof AppCoeUpdatesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coe/updates/$id': {
      id: '/_app/coe/updates/$id'
      path: '/coe/updates/$id'
      fullPath: '/coe/updates/$id'
      preLoaderRoute: typeof AppCoeUpdatesIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coe/documents/new': {
      id: '/_app/coe/documents/new'
      path: '/coe/documents/new'
      fullPath: '/coe/documents/new'
      preLoaderRoute: typeof AppCoeDocumentsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/coe/documents/$id': {
      id: '/_app/coe/documents/$id'
      path: '/coe/documents/$id'
      fullPath: '/coe/documents/$id'
      preLoaderRoute: typeof AppCoeDocumentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chatbot/conversations/$id': {
      id: '/_app/chatbot/conversations/$id'
      path: '/chatbot/conversations/$id'
      fullPath: '/chatbot/conversations/$id'
      preLoaderRoute: typeof AppChatbotConversationsIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppEventsIdRouteChildren {
  AppEventsIdRegistrationsRoute: typeof AppEventsIdRegistrationsRoute
}

const AppEventsIdRouteChildren: AppEventsIdRouteChildren = {
  AppEventsIdRegistrationsRoute: AppEventsIdRegistrationsRoute,
}

const AppEventsIdRouteWithChildren = AppEventsIdRoute._addFileChildren(
  AppEventsIdRouteChildren,
)

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppDocumentsIdRoute: typeof AppDocumentsIdRoute
  AppDocumentsNewRoute: typeof AppDocumentsNewRoute
  AppEventsIdRoute: typeof AppEventsIdRouteWithChildren
  AppEventsNewRoute: typeof AppEventsNewRoute
  AppGalleryIdRoute: typeof AppGalleryIdRoute
  AppGalleryNewRoute: typeof AppGalleryNewRoute
  AppIccComplaintsIdRoute: typeof AppIccComplaintsIdRoute
  AppAuditLogIndexRoute: typeof AppAuditLogIndexRoute
  AppDocumentsIndexRoute: typeof AppDocumentsIndexRoute
  AppEnquiriesIndexRoute: typeof AppEnquiriesIndexRoute
  AppEventsIndexRoute: typeof AppEventsIndexRoute
  AppGalleryIndexRoute: typeof AppGalleryIndexRoute
  AppIccComplaintsIndexRoute: typeof AppIccComplaintsIndexRoute
  AppMediaIndexRoute: typeof AppMediaIndexRoute
  AppPaymentsIndexRoute: typeof AppPaymentsIndexRoute
  AppPopupsIndexRoute: typeof AppPopupsIndexRoute
  AppRolesIndexRoute: typeof AppRolesIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
  AppChatbotConversationsIdRoute: typeof AppChatbotConversationsIdRoute
  AppCoeDocumentsIdRoute: typeof AppCoeDocumentsIdRoute
  AppCoeDocumentsNewRoute: typeof AppCoeDocumentsNewRoute
  AppCoeUpdatesIdRoute: typeof AppCoeUpdatesIdRoute
  AppCoeUpdatesNewRoute: typeof AppCoeUpdatesNewRoute
  AppContentBlogIdRoute: typeof AppContentBlogIdRoute
  AppContentBlogNewRoute: typeof AppContentBlogNewRoute
  AppContentNewsIdRoute: typeof AppContentNewsIdRoute
  AppContentNewsNewRoute: typeof AppContentNewsNewRoute
  AppContentPagesIdRoute: typeof AppContentPagesIdRoute
  AppContentPagesNewRoute: typeof AppContentPagesNewRoute
  AppDepartmentsAchievementsIdRoute: typeof AppDepartmentsAchievementsIdRoute
  AppDepartmentsAchievementsNewRoute: typeof AppDepartmentsAchievementsNewRoute
  AppDepartmentsCurriculumHighlightsIdRoute: typeof AppDepartmentsCurriculumHighlightsIdRoute
  AppDepartmentsCurriculumHighlightsNewRoute: typeof AppDepartmentsCurriculumHighlightsNewRoute
  AppDepartmentsCurriculumIdRoute: typeof AppDepartmentsCurriculumIdRoute
  AppDepartmentsCurriculumNewRoute: typeof AppDepartmentsCurriculumNewRoute
  AppDepartmentsEContentsIdRoute: typeof AppDepartmentsEContentsIdRoute
  AppDepartmentsEContentsNewRoute: typeof AppDepartmentsEContentsNewRoute
  AppDepartmentsFacilitiesIdRoute: typeof AppDepartmentsFacilitiesIdRoute
  AppDepartmentsFacilitiesNewRoute: typeof AppDepartmentsFacilitiesNewRoute
  AppDepartmentsFacultyIdRoute: typeof AppDepartmentsFacultyIdRoute
  AppDepartmentsFacultyNewRoute: typeof AppDepartmentsFacultyNewRoute
  AppDepartmentsFaqsIdRoute: typeof AppDepartmentsFaqsIdRoute
  AppDepartmentsFaqsNewRoute: typeof AppDepartmentsFaqsNewRoute
  AppDepartmentsGraduationIdRoute: typeof AppDepartmentsGraduationIdRoute
  AppDepartmentsGraduationNewRoute: typeof AppDepartmentsGraduationNewRoute
  AppDepartmentsInternshipsIdRoute: typeof AppDepartmentsInternshipsIdRoute
  AppDepartmentsInternshipsNewRoute: typeof AppDepartmentsInternshipsNewRoute
  AppDepartmentsLabsIdRoute: typeof AppDepartmentsLabsIdRoute
  AppDepartmentsLabsNewRoute: typeof AppDepartmentsLabsNewRoute
  AppDepartmentsMenusIdRoute: typeof AppDepartmentsMenusIdRoute
  AppDepartmentsMenusNewRoute: typeof AppDepartmentsMenusNewRoute
  AppDepartmentsNptelIdRoute: typeof AppDepartmentsNptelIdRoute
  AppDepartmentsNptelNewRoute: typeof AppDepartmentsNptelNewRoute
  AppDepartmentsOverviewsIdRoute: typeof AppDepartmentsOverviewsIdRoute
  AppDepartmentsOverviewsNewRoute: typeof AppDepartmentsOverviewsNewRoute
  AppDepartmentsPedagogyIdRoute: typeof AppDepartmentsPedagogyIdRoute
  AppDepartmentsPedagogyNewRoute: typeof AppDepartmentsPedagogyNewRoute
  AppDepartmentsPlacementsIdRoute: typeof AppDepartmentsPlacementsIdRoute
  AppDepartmentsPlacementsNewRoute: typeof AppDepartmentsPlacementsNewRoute
  AppDepartmentsPublicationsIdRoute: typeof AppDepartmentsPublicationsIdRoute
  AppDepartmentsPublicationsNewRoute: typeof AppDepartmentsPublicationsNewRoute
  AppDepartmentsRegulationsIdRoute: typeof AppDepartmentsRegulationsIdRoute
  AppDepartmentsRegulationsNewRoute: typeof AppDepartmentsRegulationsNewRoute
  AppDepartmentsResearchIdRoute: typeof AppDepartmentsResearchIdRoute
  AppDepartmentsResearchNewRoute: typeof AppDepartmentsResearchNewRoute
  AppDepartmentsTabsIdRoute: typeof AppDepartmentsTabsIdRoute
  AppDepartmentsTabsNewRoute: typeof AppDepartmentsTabsNewRoute
  AppDepartmentsTestimonialsIdRoute: typeof AppDepartmentsTestimonialsIdRoute
  AppDepartmentsTestimonialsNewRoute: typeof AppDepartmentsTestimonialsNewRoute
  AppStructureDepartmentsIdRoute: typeof AppStructureDepartmentsIdRoute
  AppStructureDepartmentsNewRoute: typeof AppStructureDepartmentsNewRoute
  AppStructureProgrammesIdRoute: typeof AppStructureProgrammesIdRoute
  AppStructureProgrammesNewRoute: typeof AppStructureProgrammesNewRoute
  AppChatbotConversationsIndexRoute: typeof AppChatbotConversationsIndexRoute
  AppChatbotFlaggedIndexRoute: typeof AppChatbotFlaggedIndexRoute
  AppChatbotKnowledgeBaseIndexRoute: typeof AppChatbotKnowledgeBaseIndexRoute
  AppCoeDocumentsIndexRoute: typeof AppCoeDocumentsIndexRoute
  AppCoeUpdatesIndexRoute: typeof AppCoeUpdatesIndexRoute
  AppContentAnnouncementsIndexRoute: typeof AppContentAnnouncementsIndexRoute
  AppContentBlogIndexRoute: typeof AppContentBlogIndexRoute
  AppContentNewsIndexRoute: typeof AppContentNewsIndexRoute
  AppContentPagesIndexRoute: typeof AppContentPagesIndexRoute
  AppDepartmentsAchievementsIndexRoute: typeof AppDepartmentsAchievementsIndexRoute
  AppDepartmentsCurriculumHighlightsIndexRoute: typeof AppDepartmentsCurriculumHighlightsIndexRoute
  AppDepartmentsCurriculumIndexRoute: typeof AppDepartmentsCurriculumIndexRoute
  AppDepartmentsEContentsIndexRoute: typeof AppDepartmentsEContentsIndexRoute
  AppDepartmentsFacilitiesIndexRoute: typeof AppDepartmentsFacilitiesIndexRoute
  AppDepartmentsFacultyIndexRoute: typeof AppDepartmentsFacultyIndexRoute
  AppDepartmentsFaqsIndexRoute: typeof AppDepartmentsFaqsIndexRoute
  AppDepartmentsGraduationIndexRoute: typeof AppDepartmentsGraduationIndexRoute
  AppDepartmentsInternshipsIndexRoute: typeof AppDepartmentsInternshipsIndexRoute
  AppDepartmentsLabsIndexRoute: typeof AppDepartmentsLabsIndexRoute
  AppDepartmentsMenusIndexRoute: typeof AppDepartmentsMenusIndexRoute
  AppDepartmentsNptelIndexRoute: typeof AppDepartmentsNptelIndexRoute
  AppDepartmentsOverviewsIndexRoute: typeof AppDepartmentsOverviewsIndexRoute
  AppDepartmentsPedagogyIndexRoute: typeof AppDepartmentsPedagogyIndexRoute
  AppDepartmentsPlacementsIndexRoute: typeof AppDepartmentsPlacementsIndexRoute
  AppDepartmentsPublicationsIndexRoute: typeof AppDepartmentsPublicationsIndexRoute
  AppDepartmentsRegulationsIndexRoute: typeof AppDepartmentsRegulationsIndexRoute
  AppDepartmentsResearchIndexRoute: typeof AppDepartmentsResearchIndexRoute
  AppDepartmentsTabsIndexRoute: typeof AppDepartmentsTabsIndexRoute
  AppDepartmentsTestimonialsIndexRoute: typeof AppDepartmentsTestimonialsIndexRoute
  AppStructureDepartmentsIndexRoute: typeof AppStructureDepartmentsIndexRoute
  AppStructureProgrammesIndexRoute: typeof AppStructureProgrammesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppDocumentsIdRoute: AppDocumentsIdRoute,
  AppDocumentsNewRoute: AppDocumentsNewRoute,
  AppEventsIdRoute: AppEventsIdRouteWithChildren,
  AppEventsNewRoute: AppEventsNewRoute,
  AppGalleryIdRoute: AppGalleryIdRoute,
  AppGalleryNewRoute: AppGalleryNewRoute,
  AppIccComplaintsIdRoute: AppIccComplaintsIdRoute,
  AppAuditLogIndexRoute: AppAuditLogIndexRoute,
  AppDocumentsIndexRoute: AppDocumentsIndexRoute,
  AppEnquiriesIndexRoute: AppEnquiriesIndexRoute,
  AppEventsIndexRoute: AppEventsIndexRoute,
  AppGalleryIndexRoute: AppGalleryIndexRoute,
  AppIccComplaintsIndexRoute: AppIccComplaintsIndexRoute,
  AppMediaIndexRoute: AppMediaIndexRoute,
  AppPaymentsIndexRoute: AppPaymentsIndexRoute,
  AppPopupsIndexRoute: AppPopupsIndexRoute,
  AppRolesIndexRoute: AppRolesIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
  AppChatbotConversationsIdRoute: AppChatbotConversationsIdRoute,
  AppCoeDocumentsIdRoute: AppCoeDocumentsIdRoute,
  AppCoeDocumentsNewRoute: AppCoeDocumentsNewRoute,
  AppCoeUpdatesIdRoute: AppCoeUpdatesIdRoute,
  AppCoeUpdatesNewRoute: AppCoeUpdatesNewRoute,
  AppContentBlogIdRoute: AppContentBlogIdRoute,
  AppContentBlogNewRoute: AppContentBlogNewRoute,
  AppContentNewsIdRoute: AppContentNewsIdRoute,
  AppContentNewsNewRoute: AppContentNewsNewRoute,
  AppContentPagesIdRoute: AppContentPagesIdRoute,
  AppContentPagesNewRoute: AppContentPagesNewRoute,
  AppDepartmentsAchievementsIdRoute: AppDepartmentsAchievementsIdRoute,
  AppDepartmentsAchievementsNewRoute: AppDepartmentsAchievementsNewRoute,
  AppDepartmentsCurriculumHighlightsIdRoute:
    AppDepartmentsCurriculumHighlightsIdRoute,
  AppDepartmentsCurriculumHighlightsNewRoute:
    AppDepartmentsCurriculumHighlightsNewRoute,
  AppDepartmentsCurriculumIdRoute: AppDepartmentsCurriculumIdRoute,
  AppDepartmentsCurriculumNewRoute: AppDepartmentsCurriculumNewRoute,
  AppDepartmentsEContentsIdRoute: AppDepartmentsEContentsIdRoute,
  AppDepartmentsEContentsNewRoute: AppDepartmentsEContentsNewRoute,
  AppDepartmentsFacilitiesIdRoute: AppDepartmentsFacilitiesIdRoute,
  AppDepartmentsFacilitiesNewRoute: AppDepartmentsFacilitiesNewRoute,
  AppDepartmentsFacultyIdRoute: AppDepartmentsFacultyIdRoute,
  AppDepartmentsFacultyNewRoute: AppDepartmentsFacultyNewRoute,
  AppDepartmentsFaqsIdRoute: AppDepartmentsFaqsIdRoute,
  AppDepartmentsFaqsNewRoute: AppDepartmentsFaqsNewRoute,
  AppDepartmentsGraduationIdRoute: AppDepartmentsGraduationIdRoute,
  AppDepartmentsGraduationNewRoute: AppDepartmentsGraduationNewRoute,
  AppDepartmentsInternshipsIdRoute: AppDepartmentsInternshipsIdRoute,
  AppDepartmentsInternshipsNewRoute: AppDepartmentsInternshipsNewRoute,
  AppDepartmentsLabsIdRoute: AppDepartmentsLabsIdRoute,
  AppDepartmentsLabsNewRoute: AppDepartmentsLabsNewRoute,
  AppDepartmentsMenusIdRoute: AppDepartmentsMenusIdRoute,
  AppDepartmentsMenusNewRoute: AppDepartmentsMenusNewRoute,
  AppDepartmentsNptelIdRoute: AppDepartmentsNptelIdRoute,
  AppDepartmentsNptelNewRoute: AppDepartmentsNptelNewRoute,
  AppDepartmentsOverviewsIdRoute: AppDepartmentsOverviewsIdRoute,
  AppDepartmentsOverviewsNewRoute: AppDepartmentsOverviewsNewRoute,
  AppDepartmentsPedagogyIdRoute: AppDepartmentsPedagogyIdRoute,
  AppDepartmentsPedagogyNewRoute: AppDepartmentsPedagogyNewRoute,
  AppDepartmentsPlacementsIdRoute: AppDepartmentsPlacementsIdRoute,
  AppDepartmentsPlacementsNewRoute: AppDepartmentsPlacementsNewRoute,
  AppDepartmentsPublicationsIdRoute: AppDepartmentsPublicationsIdRoute,
  AppDepartmentsPublicationsNewRoute: AppDepartmentsPublicationsNewRoute,
  AppDepartmentsRegulationsIdRoute: AppDepartmentsRegulationsIdRoute,
  AppDepartmentsRegulationsNewRoute: AppDepartmentsRegulationsNewRoute,
  AppDepartmentsResearchIdRoute: AppDepartmentsResearchIdRoute,
  AppDepartmentsResearchNewRoute: AppDepartmentsResearchNewRoute,
  AppDepartmentsTabsIdRoute: AppDepartmentsTabsIdRoute,
  AppDepartmentsTabsNewRoute: AppDepartmentsTabsNewRoute,
  AppDepartmentsTestimonialsIdRoute: AppDepartmentsTestimonialsIdRoute,
  AppDepartmentsTestimonialsNewRoute: AppDepartmentsTestimonialsNewRoute,
  AppStructureDepartmentsIdRoute: AppStructureDepartmentsIdRoute,
  AppStructureDepartmentsNewRoute: AppStructureDepartmentsNewRoute,
  AppStructureProgrammesIdRoute: AppStructureProgrammesIdRoute,
  AppStructureProgrammesNewRoute: AppStructureProgrammesNewRoute,
  AppChatbotConversationsIndexRoute: AppChatbotConversationsIndexRoute,
  AppChatbotFlaggedIndexRoute: AppChatbotFlaggedIndexRoute,
  AppChatbotKnowledgeBaseIndexRoute: AppChatbotKnowledgeBaseIndexRoute,
  AppCoeDocumentsIndexRoute: AppCoeDocumentsIndexRoute,
  AppCoeUpdatesIndexRoute: AppCoeUpdatesIndexRoute,
  AppContentAnnouncementsIndexRoute: AppContentAnnouncementsIndexRoute,
  AppContentBlogIndexRoute: AppContentBlogIndexRoute,
  AppContentNewsIndexRoute: AppContentNewsIndexRoute,
  AppContentPagesIndexRoute: AppContentPagesIndexRoute,
  AppDepartmentsAchievementsIndexRoute: AppDepartmentsAchievementsIndexRoute,
  AppDepartmentsCurriculumHighlightsIndexRoute:
    AppDepartmentsCurriculumHighlightsIndexRoute,
  AppDepartmentsCurriculumIndexRoute: AppDepartmentsCurriculumIndexRoute,
  AppDepartmentsEContentsIndexRoute: AppDepartmentsEContentsIndexRoute,
  AppDepartmentsFacilitiesIndexRoute: AppDepartmentsFacilitiesIndexRoute,
  AppDepartmentsFacultyIndexRoute: AppDepartmentsFacultyIndexRoute,
  AppDepartmentsFaqsIndexRoute: AppDepartmentsFaqsIndexRoute,
  AppDepartmentsGraduationIndexRoute: AppDepartmentsGraduationIndexRoute,
  AppDepartmentsInternshipsIndexRoute: AppDepartmentsInternshipsIndexRoute,
  AppDepartmentsLabsIndexRoute: AppDepartmentsLabsIndexRoute,
  AppDepartmentsMenusIndexRoute: AppDepartmentsMenusIndexRoute,
  AppDepartmentsNptelIndexRoute: AppDepartmentsNptelIndexRoute,
  AppDepartmentsOverviewsIndexRoute: AppDepartmentsOverviewsIndexRoute,
  AppDepartmentsPedagogyIndexRoute: AppDepartmentsPedagogyIndexRoute,
  AppDepartmentsPlacementsIndexRoute: AppDepartmentsPlacementsIndexRoute,
  AppDepartmentsPublicationsIndexRoute: AppDepartmentsPublicationsIndexRoute,
  AppDepartmentsRegulationsIndexRoute: AppDepartmentsRegulationsIndexRoute,
  AppDepartmentsResearchIndexRoute: AppDepartmentsResearchIndexRoute,
  AppDepartmentsTabsIndexRoute: AppDepartmentsTabsIndexRoute,
  AppDepartmentsTestimonialsIndexRoute: AppDepartmentsTestimonialsIndexRoute,
  AppStructureDepartmentsIndexRoute: AppStructureDepartmentsIndexRoute,
  AppStructureProgrammesIndexRoute: AppStructureProgrammesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
